var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __require = /* @__PURE__ */ ((x) => typeof require !== "undefined" ? require : typeof Proxy !== "undefined" ? new Proxy(x, {
  get: (a, b) => (typeof require !== "undefined" ? require : a)[b]
}) : x)(function(x) {
  if (typeof require !== "undefined")
    return require.apply(this, arguments);
  throw new Error('Dynamic require of "' + x + '" is not supported');
});
var __commonJS = (cb, mod) => function __require2() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/universalify/index.js
var require_universalify = __commonJS({
  "../../node_modules/universalify/index.js"(exports) {
    "use strict";
    exports.fromCallback = function(fn) {
      return Object.defineProperty(function(...args) {
        if (typeof args[args.length - 1] === "function")
          fn.apply(this, args);
        else {
          return new Promise((resolve, reject) => {
            fn.call(
              this,
              ...args,
              (err, res) => err != null ? reject(err) : resolve(res)
            );
          });
        }
      }, "name", { value: fn.name });
    };
    exports.fromPromise = function(fn) {
      return Object.defineProperty(function(...args) {
        const cb = args[args.length - 1];
        if (typeof cb !== "function")
          return fn.apply(this, args);
        else
          fn.apply(this, args.slice(0, -1)).then((r) => cb(null, r), cb);
      }, "name", { value: fn.name });
    };
  }
});

// ../../node_modules/graceful-fs/polyfills.js
var require_polyfills = __commonJS({
  "../../node_modules/graceful-fs/polyfills.js"(exports, module) {
    var constants = __require("constants");
    var origCwd = process.cwd;
    var cwd = null;
    var platform = process.env.GRACEFUL_FS_PLATFORM || process.platform;
    process.cwd = function() {
      if (!cwd)
        cwd = origCwd.call(process);
      return cwd;
    };
    try {
      process.cwd();
    } catch (er) {
    }
    if (typeof process.chdir === "function") {
      chdir = process.chdir;
      process.chdir = function(d) {
        cwd = null;
        chdir.call(process, d);
      };
      if (Object.setPrototypeOf)
        Object.setPrototypeOf(process.chdir, chdir);
    }
    var chdir;
    module.exports = patch;
    function patch(fs2) {
      if (constants.hasOwnProperty("O_SYMLINK") && process.version.match(/^v0\.6\.[0-2]|^v0\.5\./)) {
        patchLchmod(fs2);
      }
      if (!fs2.lutimes) {
        patchLutimes(fs2);
      }
      fs2.chown = chownFix(fs2.chown);
      fs2.fchown = chownFix(fs2.fchown);
      fs2.lchown = chownFix(fs2.lchown);
      fs2.chmod = chmodFix(fs2.chmod);
      fs2.fchmod = chmodFix(fs2.fchmod);
      fs2.lchmod = chmodFix(fs2.lchmod);
      fs2.chownSync = chownFixSync(fs2.chownSync);
      fs2.fchownSync = chownFixSync(fs2.fchownSync);
      fs2.lchownSync = chownFixSync(fs2.lchownSync);
      fs2.chmodSync = chmodFixSync(fs2.chmodSync);
      fs2.fchmodSync = chmodFixSync(fs2.fchmodSync);
      fs2.lchmodSync = chmodFixSync(fs2.lchmodSync);
      fs2.stat = statFix(fs2.stat);
      fs2.fstat = statFix(fs2.fstat);
      fs2.lstat = statFix(fs2.lstat);
      fs2.statSync = statFixSync(fs2.statSync);
      fs2.fstatSync = statFixSync(fs2.fstatSync);
      fs2.lstatSync = statFixSync(fs2.lstatSync);
      if (fs2.chmod && !fs2.lchmod) {
        fs2.lchmod = function(path2, mode, cb) {
          if (cb)
            process.nextTick(cb);
        };
        fs2.lchmodSync = function() {
        };
      }
      if (fs2.chown && !fs2.lchown) {
        fs2.lchown = function(path2, uid, gid, cb) {
          if (cb)
            process.nextTick(cb);
        };
        fs2.lchownSync = function() {
        };
      }
      if (platform === "win32") {
        fs2.rename = typeof fs2.rename !== "function" ? fs2.rename : function(fs$rename) {
          function rename(from, to, cb) {
            var start = Date.now();
            var backoff = 0;
            fs$rename(from, to, function CB(er) {
              if (er && (er.code === "EACCES" || er.code === "EPERM" || er.code === "EBUSY") && Date.now() - start < 6e4) {
                setTimeout(function() {
                  fs2.stat(to, function(stater, st) {
                    if (stater && stater.code === "ENOENT")
                      fs$rename(from, to, CB);
                    else
                      cb(er);
                  });
                }, backoff);
                if (backoff < 100)
                  backoff += 10;
                return;
              }
              if (cb)
                cb(er);
            });
          }
          if (Object.setPrototypeOf)
            Object.setPrototypeOf(rename, fs$rename);
          return rename;
        }(fs2.rename);
      }
      fs2.read = typeof fs2.read !== "function" ? fs2.read : function(fs$read) {
        function read(fd, buffer, offset, length, position, callback_) {
          var callback;
          if (callback_ && typeof callback_ === "function") {
            var eagCounter = 0;
            callback = function(er, _, __) {
              if (er && er.code === "EAGAIN" && eagCounter < 10) {
                eagCounter++;
                return fs$read.call(fs2, fd, buffer, offset, length, position, callback);
              }
              callback_.apply(this, arguments);
            };
          }
          return fs$read.call(fs2, fd, buffer, offset, length, position, callback);
        }
        if (Object.setPrototypeOf)
          Object.setPrototypeOf(read, fs$read);
        return read;
      }(fs2.read);
      fs2.readSync = typeof fs2.readSync !== "function" ? fs2.readSync : function(fs$readSync) {
        return function(fd, buffer, offset, length, position) {
          var eagCounter = 0;
          while (true) {
            try {
              return fs$readSync.call(fs2, fd, buffer, offset, length, position);
            } catch (er) {
              if (er.code === "EAGAIN" && eagCounter < 10) {
                eagCounter++;
                continue;
              }
              throw er;
            }
          }
        };
      }(fs2.readSync);
      function patchLchmod(fs3) {
        fs3.lchmod = function(path2, mode, callback) {
          fs3.open(
            path2,
            constants.O_WRONLY | constants.O_SYMLINK,
            mode,
            function(err, fd) {
              if (err) {
                if (callback)
                  callback(err);
                return;
              }
              fs3.fchmod(fd, mode, function(err2) {
                fs3.close(fd, function(err22) {
                  if (callback)
                    callback(err2 || err22);
                });
              });
            }
          );
        };
        fs3.lchmodSync = function(path2, mode) {
          var fd = fs3.openSync(path2, constants.O_WRONLY | constants.O_SYMLINK, mode);
          var threw = true;
          var ret;
          try {
            ret = fs3.fchmodSync(fd, mode);
            threw = false;
          } finally {
            if (threw) {
              try {
                fs3.closeSync(fd);
              } catch (er) {
              }
            } else {
              fs3.closeSync(fd);
            }
          }
          return ret;
        };
      }
      function patchLutimes(fs3) {
        if (constants.hasOwnProperty("O_SYMLINK") && fs3.futimes) {
          fs3.lutimes = function(path2, at, mt, cb) {
            fs3.open(path2, constants.O_SYMLINK, function(er, fd) {
              if (er) {
                if (cb)
                  cb(er);
                return;
              }
              fs3.futimes(fd, at, mt, function(er2) {
                fs3.close(fd, function(er22) {
                  if (cb)
                    cb(er2 || er22);
                });
              });
            });
          };
          fs3.lutimesSync = function(path2, at, mt) {
            var fd = fs3.openSync(path2, constants.O_SYMLINK);
            var ret;
            var threw = true;
            try {
              ret = fs3.futimesSync(fd, at, mt);
              threw = false;
            } finally {
              if (threw) {
                try {
                  fs3.closeSync(fd);
                } catch (er) {
                }
              } else {
                fs3.closeSync(fd);
              }
            }
            return ret;
          };
        } else if (fs3.futimes) {
          fs3.lutimes = function(_a, _b, _c, cb) {
            if (cb)
              process.nextTick(cb);
          };
          fs3.lutimesSync = function() {
          };
        }
      }
      function chmodFix(orig) {
        if (!orig)
          return orig;
        return function(target, mode, cb) {
          return orig.call(fs2, target, mode, function(er) {
            if (chownErOk(er))
              er = null;
            if (cb)
              cb.apply(this, arguments);
          });
        };
      }
      function chmodFixSync(orig) {
        if (!orig)
          return orig;
        return function(target, mode) {
          try {
            return orig.call(fs2, target, mode);
          } catch (er) {
            if (!chownErOk(er))
              throw er;
          }
        };
      }
      function chownFix(orig) {
        if (!orig)
          return orig;
        return function(target, uid, gid, cb) {
          return orig.call(fs2, target, uid, gid, function(er) {
            if (chownErOk(er))
              er = null;
            if (cb)
              cb.apply(this, arguments);
          });
        };
      }
      function chownFixSync(orig) {
        if (!orig)
          return orig;
        return function(target, uid, gid) {
          try {
            return orig.call(fs2, target, uid, gid);
          } catch (er) {
            if (!chownErOk(er))
              throw er;
          }
        };
      }
      function statFix(orig) {
        if (!orig)
          return orig;
        return function(target, options, cb) {
          if (typeof options === "function") {
            cb = options;
            options = null;
          }
          function callback(er, stats) {
            if (stats) {
              if (stats.uid < 0)
                stats.uid += 4294967296;
              if (stats.gid < 0)
                stats.gid += 4294967296;
            }
            if (cb)
              cb.apply(this, arguments);
          }
          return options ? orig.call(fs2, target, options, callback) : orig.call(fs2, target, callback);
        };
      }
      function statFixSync(orig) {
        if (!orig)
          return orig;
        return function(target, options) {
          var stats = options ? orig.call(fs2, target, options) : orig.call(fs2, target);
          if (stats) {
            if (stats.uid < 0)
              stats.uid += 4294967296;
            if (stats.gid < 0)
              stats.gid += 4294967296;
          }
          return stats;
        };
      }
      function chownErOk(er) {
        if (!er)
          return true;
        if (er.code === "ENOSYS")
          return true;
        var nonroot = !process.getuid || process.getuid() !== 0;
        if (nonroot) {
          if (er.code === "EINVAL" || er.code === "EPERM")
            return true;
        }
        return false;
      }
    }
  }
});

// ../../node_modules/graceful-fs/legacy-streams.js
var require_legacy_streams = __commonJS({
  "../../node_modules/graceful-fs/legacy-streams.js"(exports, module) {
    var Stream = __require("stream").Stream;
    module.exports = legacy;
    function legacy(fs2) {
      return {
        ReadStream,
        WriteStream
      };
      function ReadStream(path2, options) {
        if (!(this instanceof ReadStream))
          return new ReadStream(path2, options);
        Stream.call(this);
        var self = this;
        this.path = path2;
        this.fd = null;
        this.readable = true;
        this.paused = false;
        this.flags = "r";
        this.mode = 438;
        this.bufferSize = 64 * 1024;
        options = options || {};
        var keys = Object.keys(options);
        for (var index = 0, length = keys.length; index < length; index++) {
          var key = keys[index];
          this[key] = options[key];
        }
        if (this.encoding)
          this.setEncoding(this.encoding);
        if (this.start !== void 0) {
          if ("number" !== typeof this.start) {
            throw TypeError("start must be a Number");
          }
          if (this.end === void 0) {
            this.end = Infinity;
          } else if ("number" !== typeof this.end) {
            throw TypeError("end must be a Number");
          }
          if (this.start > this.end) {
            throw new Error("start must be <= end");
          }
          this.pos = this.start;
        }
        if (this.fd !== null) {
          process.nextTick(function() {
            self._read();
          });
          return;
        }
        fs2.open(this.path, this.flags, this.mode, function(err, fd) {
          if (err) {
            self.emit("error", err);
            self.readable = false;
            return;
          }
          self.fd = fd;
          self.emit("open", fd);
          self._read();
        });
      }
      function WriteStream(path2, options) {
        if (!(this instanceof WriteStream))
          return new WriteStream(path2, options);
        Stream.call(this);
        this.path = path2;
        this.fd = null;
        this.writable = true;
        this.flags = "w";
        this.encoding = "binary";
        this.mode = 438;
        this.bytesWritten = 0;
        options = options || {};
        var keys = Object.keys(options);
        for (var index = 0, length = keys.length; index < length; index++) {
          var key = keys[index];
          this[key] = options[key];
        }
        if (this.start !== void 0) {
          if ("number" !== typeof this.start) {
            throw TypeError("start must be a Number");
          }
          if (this.start < 0) {
            throw new Error("start must be >= zero");
          }
          this.pos = this.start;
        }
        this.busy = false;
        this._queue = [];
        if (this.fd === null) {
          this._open = fs2.open;
          this._queue.push([this._open, this.path, this.flags, this.mode, void 0]);
          this.flush();
        }
      }
    }
  }
});

// ../../node_modules/graceful-fs/clone.js
var require_clone = __commonJS({
  "../../node_modules/graceful-fs/clone.js"(exports, module) {
    "use strict";
    module.exports = clone;
    var getPrototypeOf = Object.getPrototypeOf || function(obj) {
      return obj.__proto__;
    };
    function clone(obj) {
      if (obj === null || typeof obj !== "object")
        return obj;
      if (obj instanceof Object)
        var copy = { __proto__: getPrototypeOf(obj) };
      else
        var copy = /* @__PURE__ */ Object.create(null);
      Object.getOwnPropertyNames(obj).forEach(function(key) {
        Object.defineProperty(copy, key, Object.getOwnPropertyDescriptor(obj, key));
      });
      return copy;
    }
  }
});

// ../../node_modules/graceful-fs/graceful-fs.js
var require_graceful_fs = __commonJS({
  "../../node_modules/graceful-fs/graceful-fs.js"(exports, module) {
    var fs2 = __require("fs");
    var polyfills = require_polyfills();
    var legacy = require_legacy_streams();
    var clone = require_clone();
    var util = __require("util");
    var gracefulQueue;
    var previousSymbol;
    if (typeof Symbol === "function" && typeof Symbol.for === "function") {
      gracefulQueue = Symbol.for("graceful-fs.queue");
      previousSymbol = Symbol.for("graceful-fs.previous");
    } else {
      gracefulQueue = "___graceful-fs.queue";
      previousSymbol = "___graceful-fs.previous";
    }
    function noop() {
    }
    function publishQueue(context, queue2) {
      Object.defineProperty(context, gracefulQueue, {
        get: function() {
          return queue2;
        }
      });
    }
    var debug = noop;
    if (util.debuglog)
      debug = util.debuglog("gfs4");
    else if (/\bgfs4\b/i.test(process.env.NODE_DEBUG || ""))
      debug = function() {
        var m = util.format.apply(util, arguments);
        m = "GFS4: " + m.split(/\n/).join("\nGFS4: ");
        console.error(m);
      };
    if (!fs2[gracefulQueue]) {
      queue = global[gracefulQueue] || [];
      publishQueue(fs2, queue);
      fs2.close = function(fs$close) {
        function close(fd, cb) {
          return fs$close.call(fs2, fd, function(err) {
            if (!err) {
              resetQueue();
            }
            if (typeof cb === "function")
              cb.apply(this, arguments);
          });
        }
        Object.defineProperty(close, previousSymbol, {
          value: fs$close
        });
        return close;
      }(fs2.close);
      fs2.closeSync = function(fs$closeSync) {
        function closeSync(fd) {
          fs$closeSync.apply(fs2, arguments);
          resetQueue();
        }
        Object.defineProperty(closeSync, previousSymbol, {
          value: fs$closeSync
        });
        return closeSync;
      }(fs2.closeSync);
      if (/\bgfs4\b/i.test(process.env.NODE_DEBUG || "")) {
        process.on("exit", function() {
          debug(fs2[gracefulQueue]);
          __require("assert").equal(fs2[gracefulQueue].length, 0);
        });
      }
    }
    var queue;
    if (!global[gracefulQueue]) {
      publishQueue(global, fs2[gracefulQueue]);
    }
    module.exports = patch(clone(fs2));
    if (process.env.TEST_GRACEFUL_FS_GLOBAL_PATCH && !fs2.__patched) {
      module.exports = patch(fs2);
      fs2.__patched = true;
    }
    function patch(fs3) {
      polyfills(fs3);
      fs3.gracefulify = patch;
      fs3.createReadStream = createReadStream;
      fs3.createWriteStream = createWriteStream;
      var fs$readFile = fs3.readFile;
      fs3.readFile = readFile4;
      function readFile4(path2, options, cb) {
        if (typeof options === "function")
          cb = options, options = null;
        return go$readFile(path2, options, cb);
        function go$readFile(path3, options2, cb2, startTime) {
          return fs$readFile(path3, options2, function(err) {
            if (err && (err.code === "EMFILE" || err.code === "ENFILE"))
              enqueue([go$readFile, [path3, options2, cb2], err, startTime || Date.now(), Date.now()]);
            else {
              if (typeof cb2 === "function")
                cb2.apply(this, arguments);
            }
          });
        }
      }
      var fs$writeFile = fs3.writeFile;
      fs3.writeFile = writeFile4;
      function writeFile4(path2, data, options, cb) {
        if (typeof options === "function")
          cb = options, options = null;
        return go$writeFile(path2, data, options, cb);
        function go$writeFile(path3, data2, options2, cb2, startTime) {
          return fs$writeFile(path3, data2, options2, function(err) {
            if (err && (err.code === "EMFILE" || err.code === "ENFILE"))
              enqueue([go$writeFile, [path3, data2, options2, cb2], err, startTime || Date.now(), Date.now()]);
            else {
              if (typeof cb2 === "function")
                cb2.apply(this, arguments);
            }
          });
        }
      }
      var fs$appendFile = fs3.appendFile;
      if (fs$appendFile)
        fs3.appendFile = appendFile;
      function appendFile(path2, data, options, cb) {
        if (typeof options === "function")
          cb = options, options = null;
        return go$appendFile(path2, data, options, cb);
        function go$appendFile(path3, data2, options2, cb2, startTime) {
          return fs$appendFile(path3, data2, options2, function(err) {
            if (err && (err.code === "EMFILE" || err.code === "ENFILE"))
              enqueue([go$appendFile, [path3, data2, options2, cb2], err, startTime || Date.now(), Date.now()]);
            else {
              if (typeof cb2 === "function")
                cb2.apply(this, arguments);
            }
          });
        }
      }
      var fs$copyFile = fs3.copyFile;
      if (fs$copyFile)
        fs3.copyFile = copyFile;
      function copyFile(src, dest, flags, cb) {
        if (typeof flags === "function") {
          cb = flags;
          flags = 0;
        }
        return go$copyFile(src, dest, flags, cb);
        function go$copyFile(src2, dest2, flags2, cb2, startTime) {
          return fs$copyFile(src2, dest2, flags2, function(err) {
            if (err && (err.code === "EMFILE" || err.code === "ENFILE"))
              enqueue([go$copyFile, [src2, dest2, flags2, cb2], err, startTime || Date.now(), Date.now()]);
            else {
              if (typeof cb2 === "function")
                cb2.apply(this, arguments);
            }
          });
        }
      }
      var fs$readdir = fs3.readdir;
      fs3.readdir = readdir2;
      var noReaddirOptionVersions = /^v[0-5]\./;
      function readdir2(path2, options, cb) {
        if (typeof options === "function")
          cb = options, options = null;
        var go$readdir = noReaddirOptionVersions.test(process.version) ? function go$readdir2(path3, options2, cb2, startTime) {
          return fs$readdir(path3, fs$readdirCallback(
            path3,
            options2,
            cb2,
            startTime
          ));
        } : function go$readdir2(path3, options2, cb2, startTime) {
          return fs$readdir(path3, options2, fs$readdirCallback(
            path3,
            options2,
            cb2,
            startTime
          ));
        };
        return go$readdir(path2, options, cb);
        function fs$readdirCallback(path3, options2, cb2, startTime) {
          return function(err, files) {
            if (err && (err.code === "EMFILE" || err.code === "ENFILE"))
              enqueue([
                go$readdir,
                [path3, options2, cb2],
                err,
                startTime || Date.now(),
                Date.now()
              ]);
            else {
              if (files && files.sort)
                files.sort();
              if (typeof cb2 === "function")
                cb2.call(this, err, files);
            }
          };
        }
      }
      if (process.version.substr(0, 4) === "v0.8") {
        var legStreams = legacy(fs3);
        ReadStream = legStreams.ReadStream;
        WriteStream = legStreams.WriteStream;
      }
      var fs$ReadStream = fs3.ReadStream;
      if (fs$ReadStream) {
        ReadStream.prototype = Object.create(fs$ReadStream.prototype);
        ReadStream.prototype.open = ReadStream$open;
      }
      var fs$WriteStream = fs3.WriteStream;
      if (fs$WriteStream) {
        WriteStream.prototype = Object.create(fs$WriteStream.prototype);
        WriteStream.prototype.open = WriteStream$open;
      }
      Object.defineProperty(fs3, "ReadStream", {
        get: function() {
          return ReadStream;
        },
        set: function(val) {
          ReadStream = val;
        },
        enumerable: true,
        configurable: true
      });
      Object.defineProperty(fs3, "WriteStream", {
        get: function() {
          return WriteStream;
        },
        set: function(val) {
          WriteStream = val;
        },
        enumerable: true,
        configurable: true
      });
      var FileReadStream = ReadStream;
      Object.defineProperty(fs3, "FileReadStream", {
        get: function() {
          return FileReadStream;
        },
        set: function(val) {
          FileReadStream = val;
        },
        enumerable: true,
        configurable: true
      });
      var FileWriteStream = WriteStream;
      Object.defineProperty(fs3, "FileWriteStream", {
        get: function() {
          return FileWriteStream;
        },
        set: function(val) {
          FileWriteStream = val;
        },
        enumerable: true,
        configurable: true
      });
      function ReadStream(path2, options) {
        if (this instanceof ReadStream)
          return fs$ReadStream.apply(this, arguments), this;
        else
          return ReadStream.apply(Object.create(ReadStream.prototype), arguments);
      }
      function ReadStream$open() {
        var that = this;
        open(that.path, that.flags, that.mode, function(err, fd) {
          if (err) {
            if (that.autoClose)
              that.destroy();
            that.emit("error", err);
          } else {
            that.fd = fd;
            that.emit("open", fd);
            that.read();
          }
        });
      }
      function WriteStream(path2, options) {
        if (this instanceof WriteStream)
          return fs$WriteStream.apply(this, arguments), this;
        else
          return WriteStream.apply(Object.create(WriteStream.prototype), arguments);
      }
      function WriteStream$open() {
        var that = this;
        open(that.path, that.flags, that.mode, function(err, fd) {
          if (err) {
            that.destroy();
            that.emit("error", err);
          } else {
            that.fd = fd;
            that.emit("open", fd);
          }
        });
      }
      function createReadStream(path2, options) {
        return new fs3.ReadStream(path2, options);
      }
      function createWriteStream(path2, options) {
        return new fs3.WriteStream(path2, options);
      }
      var fs$open = fs3.open;
      fs3.open = open;
      function open(path2, flags, mode, cb) {
        if (typeof mode === "function")
          cb = mode, mode = null;
        return go$open(path2, flags, mode, cb);
        function go$open(path3, flags2, mode2, cb2, startTime) {
          return fs$open(path3, flags2, mode2, function(err, fd) {
            if (err && (err.code === "EMFILE" || err.code === "ENFILE"))
              enqueue([go$open, [path3, flags2, mode2, cb2], err, startTime || Date.now(), Date.now()]);
            else {
              if (typeof cb2 === "function")
                cb2.apply(this, arguments);
            }
          });
        }
      }
      return fs3;
    }
    function enqueue(elem) {
      debug("ENQUEUE", elem[0].name, elem[1]);
      fs2[gracefulQueue].push(elem);
      retry();
    }
    var retryTimer;
    function resetQueue() {
      var now = Date.now();
      for (var i = 0; i < fs2[gracefulQueue].length; ++i) {
        if (fs2[gracefulQueue][i].length > 2) {
          fs2[gracefulQueue][i][3] = now;
          fs2[gracefulQueue][i][4] = now;
        }
      }
      retry();
    }
    function retry() {
      clearTimeout(retryTimer);
      retryTimer = void 0;
      if (fs2[gracefulQueue].length === 0)
        return;
      var elem = fs2[gracefulQueue].shift();
      var fn = elem[0];
      var args = elem[1];
      var err = elem[2];
      var startTime = elem[3];
      var lastTime = elem[4];
      if (startTime === void 0) {
        debug("RETRY", fn.name, args);
        fn.apply(null, args);
      } else if (Date.now() - startTime >= 6e4) {
        debug("TIMEOUT", fn.name, args);
        var cb = args.pop();
        if (typeof cb === "function")
          cb.call(null, err);
      } else {
        var sinceAttempt = Date.now() - lastTime;
        var sinceStart = Math.max(lastTime - startTime, 1);
        var desiredDelay = Math.min(sinceStart * 1.2, 100);
        if (sinceAttempt >= desiredDelay) {
          debug("RETRY", fn.name, args);
          fn.apply(null, args.concat([startTime]));
        } else {
          fs2[gracefulQueue].push(elem);
        }
      }
      if (retryTimer === void 0) {
        retryTimer = setTimeout(retry, 0);
      }
    }
  }
});

// ../../node_modules/fs-extra/lib/fs/index.js
var require_fs = __commonJS({
  "../../node_modules/fs-extra/lib/fs/index.js"(exports) {
    "use strict";
    var u = require_universalify().fromCallback;
    var fs2 = require_graceful_fs();
    var api = [
      "access",
      "appendFile",
      "chmod",
      "chown",
      "close",
      "copyFile",
      "fchmod",
      "fchown",
      "fdatasync",
      "fstat",
      "fsync",
      "ftruncate",
      "futimes",
      "lchmod",
      "lchown",
      "link",
      "lstat",
      "mkdir",
      "mkdtemp",
      "open",
      "opendir",
      "readdir",
      "readFile",
      "readlink",
      "realpath",
      "rename",
      "rm",
      "rmdir",
      "stat",
      "symlink",
      "truncate",
      "unlink",
      "utimes",
      "writeFile"
    ].filter((key) => {
      return typeof fs2[key] === "function";
    });
    Object.assign(exports, fs2);
    api.forEach((method) => {
      exports[method] = u(fs2[method]);
    });
    exports.exists = function(filename, callback) {
      if (typeof callback === "function") {
        return fs2.exists(filename, callback);
      }
      return new Promise((resolve) => {
        return fs2.exists(filename, resolve);
      });
    };
    exports.read = function(fd, buffer, offset, length, position, callback) {
      if (typeof callback === "function") {
        return fs2.read(fd, buffer, offset, length, position, callback);
      }
      return new Promise((resolve, reject) => {
        fs2.read(fd, buffer, offset, length, position, (err, bytesRead, buffer2) => {
          if (err)
            return reject(err);
          resolve({ bytesRead, buffer: buffer2 });
        });
      });
    };
    exports.write = function(fd, buffer, ...args) {
      if (typeof args[args.length - 1] === "function") {
        return fs2.write(fd, buffer, ...args);
      }
      return new Promise((resolve, reject) => {
        fs2.write(fd, buffer, ...args, (err, bytesWritten, buffer2) => {
          if (err)
            return reject(err);
          resolve({ bytesWritten, buffer: buffer2 });
        });
      });
    };
    exports.readv = function(fd, buffers, ...args) {
      if (typeof args[args.length - 1] === "function") {
        return fs2.readv(fd, buffers, ...args);
      }
      return new Promise((resolve, reject) => {
        fs2.readv(fd, buffers, ...args, (err, bytesRead, buffers2) => {
          if (err)
            return reject(err);
          resolve({ bytesRead, buffers: buffers2 });
        });
      });
    };
    exports.writev = function(fd, buffers, ...args) {
      if (typeof args[args.length - 1] === "function") {
        return fs2.writev(fd, buffers, ...args);
      }
      return new Promise((resolve, reject) => {
        fs2.writev(fd, buffers, ...args, (err, bytesWritten, buffers2) => {
          if (err)
            return reject(err);
          resolve({ bytesWritten, buffers: buffers2 });
        });
      });
    };
    if (typeof fs2.realpath.native === "function") {
      exports.realpath.native = u(fs2.realpath.native);
    } else {
      process.emitWarning(
        "fs.realpath.native is not a function. Is fs being monkey-patched?",
        "Warning",
        "fs-extra-WARN0003"
      );
    }
  }
});

// ../../node_modules/fs-extra/lib/mkdirs/utils.js
var require_utils = __commonJS({
  "../../node_modules/fs-extra/lib/mkdirs/utils.js"(exports, module) {
    "use strict";
    var path2 = __require("path");
    module.exports.checkPath = function checkPath(pth) {
      if (process.platform === "win32") {
        const pathHasInvalidWinCharacters = /[<>:"|?*]/.test(pth.replace(path2.parse(pth).root, ""));
        if (pathHasInvalidWinCharacters) {
          const error = new Error(`Path contains invalid characters: ${pth}`);
          error.code = "EINVAL";
          throw error;
        }
      }
    };
  }
});

// ../../node_modules/fs-extra/lib/mkdirs/make-dir.js
var require_make_dir = __commonJS({
  "../../node_modules/fs-extra/lib/mkdirs/make-dir.js"(exports, module) {
    "use strict";
    var fs2 = require_fs();
    var { checkPath } = require_utils();
    var getMode = (options) => {
      const defaults = { mode: 511 };
      if (typeof options === "number")
        return options;
      return { ...defaults, ...options }.mode;
    };
    module.exports.makeDir = async (dir, options) => {
      checkPath(dir);
      return fs2.mkdir(dir, {
        mode: getMode(options),
        recursive: true
      });
    };
    module.exports.makeDirSync = (dir, options) => {
      checkPath(dir);
      return fs2.mkdirSync(dir, {
        mode: getMode(options),
        recursive: true
      });
    };
  }
});

// ../../node_modules/fs-extra/lib/mkdirs/index.js
var require_mkdirs = __commonJS({
  "../../node_modules/fs-extra/lib/mkdirs/index.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    var { makeDir: _makeDir, makeDirSync } = require_make_dir();
    var makeDir = u(_makeDir);
    module.exports = {
      mkdirs: makeDir,
      mkdirsSync: makeDirSync,
      // alias
      mkdirp: makeDir,
      mkdirpSync: makeDirSync,
      ensureDir: makeDir,
      ensureDirSync: makeDirSync
    };
  }
});

// ../../node_modules/fs-extra/lib/path-exists/index.js
var require_path_exists = __commonJS({
  "../../node_modules/fs-extra/lib/path-exists/index.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    var fs2 = require_fs();
    function pathExists2(path2) {
      return fs2.access(path2).then(() => true).catch(() => false);
    }
    module.exports = {
      pathExists: u(pathExists2),
      pathExistsSync: fs2.existsSync
    };
  }
});

// ../../node_modules/fs-extra/lib/util/utimes.js
var require_utimes = __commonJS({
  "../../node_modules/fs-extra/lib/util/utimes.js"(exports, module) {
    "use strict";
    var fs2 = require_fs();
    var u = require_universalify().fromPromise;
    async function utimesMillis(path2, atime, mtime) {
      const fd = await fs2.open(path2, "r+");
      let closeErr = null;
      try {
        await fs2.futimes(fd, atime, mtime);
      } finally {
        try {
          await fs2.close(fd);
        } catch (e) {
          closeErr = e;
        }
      }
      if (closeErr) {
        throw closeErr;
      }
    }
    function utimesMillisSync(path2, atime, mtime) {
      const fd = fs2.openSync(path2, "r+");
      fs2.futimesSync(fd, atime, mtime);
      return fs2.closeSync(fd);
    }
    module.exports = {
      utimesMillis: u(utimesMillis),
      utimesMillisSync
    };
  }
});

// ../../node_modules/fs-extra/lib/util/stat.js
var require_stat = __commonJS({
  "../../node_modules/fs-extra/lib/util/stat.js"(exports, module) {
    "use strict";
    var fs2 = require_fs();
    var path2 = __require("path");
    var u = require_universalify().fromPromise;
    function getStats(src, dest, opts) {
      const statFunc = opts.dereference ? (file) => fs2.stat(file, { bigint: true }) : (file) => fs2.lstat(file, { bigint: true });
      return Promise.all([
        statFunc(src),
        statFunc(dest).catch((err) => {
          if (err.code === "ENOENT")
            return null;
          throw err;
        })
      ]).then(([srcStat, destStat]) => ({ srcStat, destStat }));
    }
    function getStatsSync(src, dest, opts) {
      let destStat;
      const statFunc = opts.dereference ? (file) => fs2.statSync(file, { bigint: true }) : (file) => fs2.lstatSync(file, { bigint: true });
      const srcStat = statFunc(src);
      try {
        destStat = statFunc(dest);
      } catch (err) {
        if (err.code === "ENOENT")
          return { srcStat, destStat: null };
        throw err;
      }
      return { srcStat, destStat };
    }
    async function checkPaths(src, dest, funcName, opts) {
      const { srcStat, destStat } = await getStats(src, dest, opts);
      if (destStat) {
        if (areIdentical(srcStat, destStat)) {
          const srcBaseName = path2.basename(src);
          const destBaseName = path2.basename(dest);
          if (funcName === "move" && srcBaseName !== destBaseName && srcBaseName.toLowerCase() === destBaseName.toLowerCase()) {
            return { srcStat, destStat, isChangingCase: true };
          }
          throw new Error("Source and destination must not be the same.");
        }
        if (srcStat.isDirectory() && !destStat.isDirectory()) {
          throw new Error(`Cannot overwrite non-directory '${dest}' with directory '${src}'.`);
        }
        if (!srcStat.isDirectory() && destStat.isDirectory()) {
          throw new Error(`Cannot overwrite directory '${dest}' with non-directory '${src}'.`);
        }
      }
      if (srcStat.isDirectory() && isSrcSubdir(src, dest)) {
        throw new Error(errMsg(src, dest, funcName));
      }
      return { srcStat, destStat };
    }
    function checkPathsSync(src, dest, funcName, opts) {
      const { srcStat, destStat } = getStatsSync(src, dest, opts);
      if (destStat) {
        if (areIdentical(srcStat, destStat)) {
          const srcBaseName = path2.basename(src);
          const destBaseName = path2.basename(dest);
          if (funcName === "move" && srcBaseName !== destBaseName && srcBaseName.toLowerCase() === destBaseName.toLowerCase()) {
            return { srcStat, destStat, isChangingCase: true };
          }
          throw new Error("Source and destination must not be the same.");
        }
        if (srcStat.isDirectory() && !destStat.isDirectory()) {
          throw new Error(`Cannot overwrite non-directory '${dest}' with directory '${src}'.`);
        }
        if (!srcStat.isDirectory() && destStat.isDirectory()) {
          throw new Error(`Cannot overwrite directory '${dest}' with non-directory '${src}'.`);
        }
      }
      if (srcStat.isDirectory() && isSrcSubdir(src, dest)) {
        throw new Error(errMsg(src, dest, funcName));
      }
      return { srcStat, destStat };
    }
    async function checkParentPaths(src, srcStat, dest, funcName) {
      const srcParent = path2.resolve(path2.dirname(src));
      const destParent = path2.resolve(path2.dirname(dest));
      if (destParent === srcParent || destParent === path2.parse(destParent).root)
        return;
      let destStat;
      try {
        destStat = await fs2.stat(destParent, { bigint: true });
      } catch (err) {
        if (err.code === "ENOENT")
          return;
        throw err;
      }
      if (areIdentical(srcStat, destStat)) {
        throw new Error(errMsg(src, dest, funcName));
      }
      return checkParentPaths(src, srcStat, destParent, funcName);
    }
    function checkParentPathsSync(src, srcStat, dest, funcName) {
      const srcParent = path2.resolve(path2.dirname(src));
      const destParent = path2.resolve(path2.dirname(dest));
      if (destParent === srcParent || destParent === path2.parse(destParent).root)
        return;
      let destStat;
      try {
        destStat = fs2.statSync(destParent, { bigint: true });
      } catch (err) {
        if (err.code === "ENOENT")
          return;
        throw err;
      }
      if (areIdentical(srcStat, destStat)) {
        throw new Error(errMsg(src, dest, funcName));
      }
      return checkParentPathsSync(src, srcStat, destParent, funcName);
    }
    function areIdentical(srcStat, destStat) {
      return destStat.ino && destStat.dev && destStat.ino === srcStat.ino && destStat.dev === srcStat.dev;
    }
    function isSrcSubdir(src, dest) {
      const srcArr = path2.resolve(src).split(path2.sep).filter((i) => i);
      const destArr = path2.resolve(dest).split(path2.sep).filter((i) => i);
      return srcArr.every((cur, i) => destArr[i] === cur);
    }
    function errMsg(src, dest, funcName) {
      return `Cannot ${funcName} '${src}' to a subdirectory of itself, '${dest}'.`;
    }
    module.exports = {
      // checkPaths
      checkPaths: u(checkPaths),
      checkPathsSync,
      // checkParent
      checkParentPaths: u(checkParentPaths),
      checkParentPathsSync,
      // Misc
      isSrcSubdir,
      areIdentical
    };
  }
});

// ../../node_modules/fs-extra/lib/copy/copy.js
var require_copy = __commonJS({
  "../../node_modules/fs-extra/lib/copy/copy.js"(exports, module) {
    "use strict";
    var fs2 = require_fs();
    var path2 = __require("path");
    var { mkdirs } = require_mkdirs();
    var { pathExists: pathExists2 } = require_path_exists();
    var { utimesMillis } = require_utimes();
    var stat = require_stat();
    async function copy(src, dest, opts = {}) {
      if (typeof opts === "function") {
        opts = { filter: opts };
      }
      opts.clobber = "clobber" in opts ? !!opts.clobber : true;
      opts.overwrite = "overwrite" in opts ? !!opts.overwrite : opts.clobber;
      if (opts.preserveTimestamps && process.arch === "ia32") {
        process.emitWarning(
          "Using the preserveTimestamps option in 32-bit node is not recommended;\n\n	see https://github.com/jprichardson/node-fs-extra/issues/269",
          "Warning",
          "fs-extra-WARN0001"
        );
      }
      const { srcStat, destStat } = await stat.checkPaths(src, dest, "copy", opts);
      await stat.checkParentPaths(src, srcStat, dest, "copy");
      const include = await runFilter(src, dest, opts);
      if (!include)
        return;
      const destParent = path2.dirname(dest);
      const dirExists = await pathExists2(destParent);
      if (!dirExists) {
        await mkdirs(destParent);
      }
      await getStatsAndPerformCopy(destStat, src, dest, opts);
    }
    async function runFilter(src, dest, opts) {
      if (!opts.filter)
        return true;
      return opts.filter(src, dest);
    }
    async function getStatsAndPerformCopy(destStat, src, dest, opts) {
      const statFn = opts.dereference ? fs2.stat : fs2.lstat;
      const srcStat = await statFn(src);
      if (srcStat.isDirectory())
        return onDir(srcStat, destStat, src, dest, opts);
      if (srcStat.isFile() || srcStat.isCharacterDevice() || srcStat.isBlockDevice())
        return onFile(srcStat, destStat, src, dest, opts);
      if (srcStat.isSymbolicLink())
        return onLink(destStat, src, dest, opts);
      if (srcStat.isSocket())
        throw new Error(`Cannot copy a socket file: ${src}`);
      if (srcStat.isFIFO())
        throw new Error(`Cannot copy a FIFO pipe: ${src}`);
      throw new Error(`Unknown file: ${src}`);
    }
    async function onFile(srcStat, destStat, src, dest, opts) {
      if (!destStat)
        return copyFile(srcStat, src, dest, opts);
      if (opts.overwrite) {
        await fs2.unlink(dest);
        return copyFile(srcStat, src, dest, opts);
      }
      if (opts.errorOnExist) {
        throw new Error(`'${dest}' already exists`);
      }
    }
    async function copyFile(srcStat, src, dest, opts) {
      await fs2.copyFile(src, dest);
      if (opts.preserveTimestamps) {
        if (fileIsNotWritable(srcStat.mode)) {
          await makeFileWritable(dest, srcStat.mode);
        }
        const updatedSrcStat = await fs2.stat(src);
        await utimesMillis(dest, updatedSrcStat.atime, updatedSrcStat.mtime);
      }
      return fs2.chmod(dest, srcStat.mode);
    }
    function fileIsNotWritable(srcMode) {
      return (srcMode & 128) === 0;
    }
    function makeFileWritable(dest, srcMode) {
      return fs2.chmod(dest, srcMode | 128);
    }
    async function onDir(srcStat, destStat, src, dest, opts) {
      if (!destStat) {
        await fs2.mkdir(dest);
      }
      const items = await fs2.readdir(src);
      await Promise.all(items.map(async (item) => {
        const srcItem = path2.join(src, item);
        const destItem = path2.join(dest, item);
        const include = await runFilter(srcItem, destItem, opts);
        if (!include)
          return;
        const { destStat: destStat2 } = await stat.checkPaths(srcItem, destItem, "copy", opts);
        return getStatsAndPerformCopy(destStat2, srcItem, destItem, opts);
      }));
      if (!destStat) {
        await fs2.chmod(dest, srcStat.mode);
      }
    }
    async function onLink(destStat, src, dest, opts) {
      let resolvedSrc = await fs2.readlink(src);
      if (opts.dereference) {
        resolvedSrc = path2.resolve(process.cwd(), resolvedSrc);
      }
      if (!destStat) {
        return fs2.symlink(resolvedSrc, dest);
      }
      let resolvedDest = null;
      try {
        resolvedDest = await fs2.readlink(dest);
      } catch (e) {
        if (e.code === "EINVAL" || e.code === "UNKNOWN")
          return fs2.symlink(resolvedSrc, dest);
        throw e;
      }
      if (opts.dereference) {
        resolvedDest = path2.resolve(process.cwd(), resolvedDest);
      }
      if (stat.isSrcSubdir(resolvedSrc, resolvedDest)) {
        throw new Error(`Cannot copy '${resolvedSrc}' to a subdirectory of itself, '${resolvedDest}'.`);
      }
      if (stat.isSrcSubdir(resolvedDest, resolvedSrc)) {
        throw new Error(`Cannot overwrite '${resolvedDest}' with '${resolvedSrc}'.`);
      }
      await fs2.unlink(dest);
      return fs2.symlink(resolvedSrc, dest);
    }
    module.exports = copy;
  }
});

// ../../node_modules/fs-extra/lib/copy/copy-sync.js
var require_copy_sync = __commonJS({
  "../../node_modules/fs-extra/lib/copy/copy-sync.js"(exports, module) {
    "use strict";
    var fs2 = require_graceful_fs();
    var path2 = __require("path");
    var mkdirsSync = require_mkdirs().mkdirsSync;
    var utimesMillisSync = require_utimes().utimesMillisSync;
    var stat = require_stat();
    function copySync(src, dest, opts) {
      if (typeof opts === "function") {
        opts = { filter: opts };
      }
      opts = opts || {};
      opts.clobber = "clobber" in opts ? !!opts.clobber : true;
      opts.overwrite = "overwrite" in opts ? !!opts.overwrite : opts.clobber;
      if (opts.preserveTimestamps && process.arch === "ia32") {
        process.emitWarning(
          "Using the preserveTimestamps option in 32-bit node is not recommended;\n\n	see https://github.com/jprichardson/node-fs-extra/issues/269",
          "Warning",
          "fs-extra-WARN0002"
        );
      }
      const { srcStat, destStat } = stat.checkPathsSync(src, dest, "copy", opts);
      stat.checkParentPathsSync(src, srcStat, dest, "copy");
      if (opts.filter && !opts.filter(src, dest))
        return;
      const destParent = path2.dirname(dest);
      if (!fs2.existsSync(destParent))
        mkdirsSync(destParent);
      return getStats(destStat, src, dest, opts);
    }
    function getStats(destStat, src, dest, opts) {
      const statSync = opts.dereference ? fs2.statSync : fs2.lstatSync;
      const srcStat = statSync(src);
      if (srcStat.isDirectory())
        return onDir(srcStat, destStat, src, dest, opts);
      else if (srcStat.isFile() || srcStat.isCharacterDevice() || srcStat.isBlockDevice())
        return onFile(srcStat, destStat, src, dest, opts);
      else if (srcStat.isSymbolicLink())
        return onLink(destStat, src, dest, opts);
      else if (srcStat.isSocket())
        throw new Error(`Cannot copy a socket file: ${src}`);
      else if (srcStat.isFIFO())
        throw new Error(`Cannot copy a FIFO pipe: ${src}`);
      throw new Error(`Unknown file: ${src}`);
    }
    function onFile(srcStat, destStat, src, dest, opts) {
      if (!destStat)
        return copyFile(srcStat, src, dest, opts);
      return mayCopyFile(srcStat, src, dest, opts);
    }
    function mayCopyFile(srcStat, src, dest, opts) {
      if (opts.overwrite) {
        fs2.unlinkSync(dest);
        return copyFile(srcStat, src, dest, opts);
      } else if (opts.errorOnExist) {
        throw new Error(`'${dest}' already exists`);
      }
    }
    function copyFile(srcStat, src, dest, opts) {
      fs2.copyFileSync(src, dest);
      if (opts.preserveTimestamps)
        handleTimestamps(srcStat.mode, src, dest);
      return setDestMode(dest, srcStat.mode);
    }
    function handleTimestamps(srcMode, src, dest) {
      if (fileIsNotWritable(srcMode))
        makeFileWritable(dest, srcMode);
      return setDestTimestamps(src, dest);
    }
    function fileIsNotWritable(srcMode) {
      return (srcMode & 128) === 0;
    }
    function makeFileWritable(dest, srcMode) {
      return setDestMode(dest, srcMode | 128);
    }
    function setDestMode(dest, srcMode) {
      return fs2.chmodSync(dest, srcMode);
    }
    function setDestTimestamps(src, dest) {
      const updatedSrcStat = fs2.statSync(src);
      return utimesMillisSync(dest, updatedSrcStat.atime, updatedSrcStat.mtime);
    }
    function onDir(srcStat, destStat, src, dest, opts) {
      if (!destStat)
        return mkDirAndCopy(srcStat.mode, src, dest, opts);
      return copyDir(src, dest, opts);
    }
    function mkDirAndCopy(srcMode, src, dest, opts) {
      fs2.mkdirSync(dest);
      copyDir(src, dest, opts);
      return setDestMode(dest, srcMode);
    }
    function copyDir(src, dest, opts) {
      fs2.readdirSync(src).forEach((item) => copyDirItem(item, src, dest, opts));
    }
    function copyDirItem(item, src, dest, opts) {
      const srcItem = path2.join(src, item);
      const destItem = path2.join(dest, item);
      if (opts.filter && !opts.filter(srcItem, destItem))
        return;
      const { destStat } = stat.checkPathsSync(srcItem, destItem, "copy", opts);
      return getStats(destStat, srcItem, destItem, opts);
    }
    function onLink(destStat, src, dest, opts) {
      let resolvedSrc = fs2.readlinkSync(src);
      if (opts.dereference) {
        resolvedSrc = path2.resolve(process.cwd(), resolvedSrc);
      }
      if (!destStat) {
        return fs2.symlinkSync(resolvedSrc, dest);
      } else {
        let resolvedDest;
        try {
          resolvedDest = fs2.readlinkSync(dest);
        } catch (err) {
          if (err.code === "EINVAL" || err.code === "UNKNOWN")
            return fs2.symlinkSync(resolvedSrc, dest);
          throw err;
        }
        if (opts.dereference) {
          resolvedDest = path2.resolve(process.cwd(), resolvedDest);
        }
        if (stat.isSrcSubdir(resolvedSrc, resolvedDest)) {
          throw new Error(`Cannot copy '${resolvedSrc}' to a subdirectory of itself, '${resolvedDest}'.`);
        }
        if (stat.isSrcSubdir(resolvedDest, resolvedSrc)) {
          throw new Error(`Cannot overwrite '${resolvedDest}' with '${resolvedSrc}'.`);
        }
        return copyLink(resolvedSrc, dest);
      }
    }
    function copyLink(resolvedSrc, dest) {
      fs2.unlinkSync(dest);
      return fs2.symlinkSync(resolvedSrc, dest);
    }
    module.exports = copySync;
  }
});

// ../../node_modules/fs-extra/lib/copy/index.js
var require_copy2 = __commonJS({
  "../../node_modules/fs-extra/lib/copy/index.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    module.exports = {
      copy: u(require_copy()),
      copySync: require_copy_sync()
    };
  }
});

// ../../node_modules/fs-extra/lib/remove/index.js
var require_remove = __commonJS({
  "../../node_modules/fs-extra/lib/remove/index.js"(exports, module) {
    "use strict";
    var fs2 = require_graceful_fs();
    var u = require_universalify().fromCallback;
    function remove(path2, callback) {
      fs2.rm(path2, { recursive: true, force: true }, callback);
    }
    function removeSync(path2) {
      fs2.rmSync(path2, { recursive: true, force: true });
    }
    module.exports = {
      remove: u(remove),
      removeSync
    };
  }
});

// ../../node_modules/fs-extra/lib/empty/index.js
var require_empty = __commonJS({
  "../../node_modules/fs-extra/lib/empty/index.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    var fs2 = require_fs();
    var path2 = __require("path");
    var mkdir6 = require_mkdirs();
    var remove = require_remove();
    var emptyDir = u(async function emptyDir2(dir) {
      let items;
      try {
        items = await fs2.readdir(dir);
      } catch {
        return mkdir6.mkdirs(dir);
      }
      return Promise.all(items.map((item) => remove.remove(path2.join(dir, item))));
    });
    function emptyDirSync(dir) {
      let items;
      try {
        items = fs2.readdirSync(dir);
      } catch {
        return mkdir6.mkdirsSync(dir);
      }
      items.forEach((item) => {
        item = path2.join(dir, item);
        remove.removeSync(item);
      });
    }
    module.exports = {
      emptyDirSync,
      emptydirSync: emptyDirSync,
      emptyDir,
      emptydir: emptyDir
    };
  }
});

// ../../node_modules/fs-extra/lib/ensure/file.js
var require_file = __commonJS({
  "../../node_modules/fs-extra/lib/ensure/file.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    var path2 = __require("path");
    var fs2 = require_fs();
    var mkdir6 = require_mkdirs();
    async function createFile(file) {
      let stats;
      try {
        stats = await fs2.stat(file);
      } catch {
      }
      if (stats && stats.isFile())
        return;
      const dir = path2.dirname(file);
      let dirStats = null;
      try {
        dirStats = await fs2.stat(dir);
      } catch (err) {
        if (err.code === "ENOENT") {
          await mkdir6.mkdirs(dir);
          await fs2.writeFile(file, "");
          return;
        } else {
          throw err;
        }
      }
      if (dirStats.isDirectory()) {
        await fs2.writeFile(file, "");
      } else {
        await fs2.readdir(dir);
      }
    }
    function createFileSync(file) {
      let stats;
      try {
        stats = fs2.statSync(file);
      } catch {
      }
      if (stats && stats.isFile())
        return;
      const dir = path2.dirname(file);
      try {
        if (!fs2.statSync(dir).isDirectory()) {
          fs2.readdirSync(dir);
        }
      } catch (err) {
        if (err && err.code === "ENOENT")
          mkdir6.mkdirsSync(dir);
        else
          throw err;
      }
      fs2.writeFileSync(file, "");
    }
    module.exports = {
      createFile: u(createFile),
      createFileSync
    };
  }
});

// ../../node_modules/fs-extra/lib/ensure/link.js
var require_link = __commonJS({
  "../../node_modules/fs-extra/lib/ensure/link.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    var path2 = __require("path");
    var fs2 = require_fs();
    var mkdir6 = require_mkdirs();
    var { pathExists: pathExists2 } = require_path_exists();
    var { areIdentical } = require_stat();
    async function createLink(srcpath, dstpath) {
      let dstStat;
      try {
        dstStat = await fs2.lstat(dstpath);
      } catch {
      }
      let srcStat;
      try {
        srcStat = await fs2.lstat(srcpath);
      } catch (err) {
        err.message = err.message.replace("lstat", "ensureLink");
        throw err;
      }
      if (dstStat && areIdentical(srcStat, dstStat))
        return;
      const dir = path2.dirname(dstpath);
      const dirExists = await pathExists2(dir);
      if (!dirExists) {
        await mkdir6.mkdirs(dir);
      }
      await fs2.link(srcpath, dstpath);
    }
    function createLinkSync(srcpath, dstpath) {
      let dstStat;
      try {
        dstStat = fs2.lstatSync(dstpath);
      } catch {
      }
      try {
        const srcStat = fs2.lstatSync(srcpath);
        if (dstStat && areIdentical(srcStat, dstStat))
          return;
      } catch (err) {
        err.message = err.message.replace("lstat", "ensureLink");
        throw err;
      }
      const dir = path2.dirname(dstpath);
      const dirExists = fs2.existsSync(dir);
      if (dirExists)
        return fs2.linkSync(srcpath, dstpath);
      mkdir6.mkdirsSync(dir);
      return fs2.linkSync(srcpath, dstpath);
    }
    module.exports = {
      createLink: u(createLink),
      createLinkSync
    };
  }
});

// ../../node_modules/fs-extra/lib/ensure/symlink-paths.js
var require_symlink_paths = __commonJS({
  "../../node_modules/fs-extra/lib/ensure/symlink-paths.js"(exports, module) {
    "use strict";
    var path2 = __require("path");
    var fs2 = require_fs();
    var { pathExists: pathExists2 } = require_path_exists();
    var u = require_universalify().fromPromise;
    async function symlinkPaths(srcpath, dstpath) {
      if (path2.isAbsolute(srcpath)) {
        try {
          await fs2.lstat(srcpath);
        } catch (err) {
          err.message = err.message.replace("lstat", "ensureSymlink");
          throw err;
        }
        return {
          toCwd: srcpath,
          toDst: srcpath
        };
      }
      const dstdir = path2.dirname(dstpath);
      const relativeToDst = path2.join(dstdir, srcpath);
      const exists = await pathExists2(relativeToDst);
      if (exists) {
        return {
          toCwd: relativeToDst,
          toDst: srcpath
        };
      }
      try {
        await fs2.lstat(srcpath);
      } catch (err) {
        err.message = err.message.replace("lstat", "ensureSymlink");
        throw err;
      }
      return {
        toCwd: srcpath,
        toDst: path2.relative(dstdir, srcpath)
      };
    }
    function symlinkPathsSync(srcpath, dstpath) {
      if (path2.isAbsolute(srcpath)) {
        const exists2 = fs2.existsSync(srcpath);
        if (!exists2)
          throw new Error("absolute srcpath does not exist");
        return {
          toCwd: srcpath,
          toDst: srcpath
        };
      }
      const dstdir = path2.dirname(dstpath);
      const relativeToDst = path2.join(dstdir, srcpath);
      const exists = fs2.existsSync(relativeToDst);
      if (exists) {
        return {
          toCwd: relativeToDst,
          toDst: srcpath
        };
      }
      const srcExists = fs2.existsSync(srcpath);
      if (!srcExists)
        throw new Error("relative srcpath does not exist");
      return {
        toCwd: srcpath,
        toDst: path2.relative(dstdir, srcpath)
      };
    }
    module.exports = {
      symlinkPaths: u(symlinkPaths),
      symlinkPathsSync
    };
  }
});

// ../../node_modules/fs-extra/lib/ensure/symlink-type.js
var require_symlink_type = __commonJS({
  "../../node_modules/fs-extra/lib/ensure/symlink-type.js"(exports, module) {
    "use strict";
    var fs2 = require_fs();
    var u = require_universalify().fromPromise;
    async function symlinkType(srcpath, type) {
      if (type)
        return type;
      let stats;
      try {
        stats = await fs2.lstat(srcpath);
      } catch {
        return "file";
      }
      return stats && stats.isDirectory() ? "dir" : "file";
    }
    function symlinkTypeSync(srcpath, type) {
      if (type)
        return type;
      let stats;
      try {
        stats = fs2.lstatSync(srcpath);
      } catch {
        return "file";
      }
      return stats && stats.isDirectory() ? "dir" : "file";
    }
    module.exports = {
      symlinkType: u(symlinkType),
      symlinkTypeSync
    };
  }
});

// ../../node_modules/fs-extra/lib/ensure/symlink.js
var require_symlink = __commonJS({
  "../../node_modules/fs-extra/lib/ensure/symlink.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    var path2 = __require("path");
    var fs2 = require_fs();
    var { mkdirs, mkdirsSync } = require_mkdirs();
    var { symlinkPaths, symlinkPathsSync } = require_symlink_paths();
    var { symlinkType, symlinkTypeSync } = require_symlink_type();
    var { pathExists: pathExists2 } = require_path_exists();
    var { areIdentical } = require_stat();
    async function createSymlink(srcpath, dstpath, type) {
      let stats;
      try {
        stats = await fs2.lstat(dstpath);
      } catch {
      }
      if (stats && stats.isSymbolicLink()) {
        const [srcStat, dstStat] = await Promise.all([
          fs2.stat(srcpath),
          fs2.stat(dstpath)
        ]);
        if (areIdentical(srcStat, dstStat))
          return;
      }
      const relative5 = await symlinkPaths(srcpath, dstpath);
      srcpath = relative5.toDst;
      const toType = await symlinkType(relative5.toCwd, type);
      const dir = path2.dirname(dstpath);
      if (!await pathExists2(dir)) {
        await mkdirs(dir);
      }
      return fs2.symlink(srcpath, dstpath, toType);
    }
    function createSymlinkSync(srcpath, dstpath, type) {
      let stats;
      try {
        stats = fs2.lstatSync(dstpath);
      } catch {
      }
      if (stats && stats.isSymbolicLink()) {
        const srcStat = fs2.statSync(srcpath);
        const dstStat = fs2.statSync(dstpath);
        if (areIdentical(srcStat, dstStat))
          return;
      }
      const relative5 = symlinkPathsSync(srcpath, dstpath);
      srcpath = relative5.toDst;
      type = symlinkTypeSync(relative5.toCwd, type);
      const dir = path2.dirname(dstpath);
      const exists = fs2.existsSync(dir);
      if (exists)
        return fs2.symlinkSync(srcpath, dstpath, type);
      mkdirsSync(dir);
      return fs2.symlinkSync(srcpath, dstpath, type);
    }
    module.exports = {
      createSymlink: u(createSymlink),
      createSymlinkSync
    };
  }
});

// ../../node_modules/fs-extra/lib/ensure/index.js
var require_ensure = __commonJS({
  "../../node_modules/fs-extra/lib/ensure/index.js"(exports, module) {
    "use strict";
    var { createFile, createFileSync } = require_file();
    var { createLink, createLinkSync } = require_link();
    var { createSymlink, createSymlinkSync } = require_symlink();
    module.exports = {
      // file
      createFile,
      createFileSync,
      ensureFile: createFile,
      ensureFileSync: createFileSync,
      // link
      createLink,
      createLinkSync,
      ensureLink: createLink,
      ensureLinkSync: createLinkSync,
      // symlink
      createSymlink,
      createSymlinkSync,
      ensureSymlink: createSymlink,
      ensureSymlinkSync: createSymlinkSync
    };
  }
});

// ../../node_modules/jsonfile/utils.js
var require_utils2 = __commonJS({
  "../../node_modules/jsonfile/utils.js"(exports, module) {
    function stringify3(obj, { EOL: EOL2 = "\n", finalEOL = true, replacer = null, spaces } = {}) {
      const EOF = finalEOL ? EOL2 : "";
      const str = JSON.stringify(obj, replacer, spaces);
      return str.replace(/\n/g, EOL2) + EOF;
    }
    function stripBom(content) {
      if (Buffer.isBuffer(content))
        content = content.toString("utf8");
      return content.replace(/^\uFEFF/, "");
    }
    module.exports = { stringify: stringify3, stripBom };
  }
});

// ../../node_modules/jsonfile/index.js
var require_jsonfile = __commonJS({
  "../../node_modules/jsonfile/index.js"(exports, module) {
    var _fs;
    try {
      _fs = require_graceful_fs();
    } catch (_) {
      _fs = __require("fs");
    }
    var universalify = require_universalify();
    var { stringify: stringify3, stripBom } = require_utils2();
    async function _readFile(file, options = {}) {
      if (typeof options === "string") {
        options = { encoding: options };
      }
      const fs2 = options.fs || _fs;
      const shouldThrow = "throws" in options ? options.throws : true;
      let data = await universalify.fromCallback(fs2.readFile)(file, options);
      data = stripBom(data);
      let obj;
      try {
        obj = JSON.parse(data, options ? options.reviver : null);
      } catch (err) {
        if (shouldThrow) {
          err.message = `${file}: ${err.message}`;
          throw err;
        } else {
          return null;
        }
      }
      return obj;
    }
    var readFile4 = universalify.fromPromise(_readFile);
    function readFileSync(file, options = {}) {
      if (typeof options === "string") {
        options = { encoding: options };
      }
      const fs2 = options.fs || _fs;
      const shouldThrow = "throws" in options ? options.throws : true;
      try {
        let content = fs2.readFileSync(file, options);
        content = stripBom(content);
        return JSON.parse(content, options.reviver);
      } catch (err) {
        if (shouldThrow) {
          err.message = `${file}: ${err.message}`;
          throw err;
        } else {
          return null;
        }
      }
    }
    async function _writeFile(file, obj, options = {}) {
      const fs2 = options.fs || _fs;
      const str = stringify3(obj, options);
      await universalify.fromCallback(fs2.writeFile)(file, str, options);
    }
    var writeFile4 = universalify.fromPromise(_writeFile);
    function writeFileSync(file, obj, options = {}) {
      const fs2 = options.fs || _fs;
      const str = stringify3(obj, options);
      return fs2.writeFileSync(file, str, options);
    }
    var jsonfile = {
      readFile: readFile4,
      readFileSync,
      writeFile: writeFile4,
      writeFileSync
    };
    module.exports = jsonfile;
  }
});

// ../../node_modules/fs-extra/lib/json/jsonfile.js
var require_jsonfile2 = __commonJS({
  "../../node_modules/fs-extra/lib/json/jsonfile.js"(exports, module) {
    "use strict";
    var jsonFile = require_jsonfile();
    module.exports = {
      // jsonfile exports
      readJson: jsonFile.readFile,
      readJsonSync: jsonFile.readFileSync,
      writeJson: jsonFile.writeFile,
      writeJsonSync: jsonFile.writeFileSync
    };
  }
});

// ../../node_modules/fs-extra/lib/output-file/index.js
var require_output_file = __commonJS({
  "../../node_modules/fs-extra/lib/output-file/index.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    var fs2 = require_fs();
    var path2 = __require("path");
    var mkdir6 = require_mkdirs();
    var pathExists2 = require_path_exists().pathExists;
    async function outputFile(file, data, encoding = "utf-8") {
      const dir = path2.dirname(file);
      if (!await pathExists2(dir)) {
        await mkdir6.mkdirs(dir);
      }
      return fs2.writeFile(file, data, encoding);
    }
    function outputFileSync(file, ...args) {
      const dir = path2.dirname(file);
      if (!fs2.existsSync(dir)) {
        mkdir6.mkdirsSync(dir);
      }
      fs2.writeFileSync(file, ...args);
    }
    module.exports = {
      outputFile: u(outputFile),
      outputFileSync
    };
  }
});

// ../../node_modules/fs-extra/lib/json/output-json.js
var require_output_json = __commonJS({
  "../../node_modules/fs-extra/lib/json/output-json.js"(exports, module) {
    "use strict";
    var { stringify: stringify3 } = require_utils2();
    var { outputFile } = require_output_file();
    async function outputJson(file, data, options = {}) {
      const str = stringify3(data, options);
      await outputFile(file, str, options);
    }
    module.exports = outputJson;
  }
});

// ../../node_modules/fs-extra/lib/json/output-json-sync.js
var require_output_json_sync = __commonJS({
  "../../node_modules/fs-extra/lib/json/output-json-sync.js"(exports, module) {
    "use strict";
    var { stringify: stringify3 } = require_utils2();
    var { outputFileSync } = require_output_file();
    function outputJsonSync(file, data, options) {
      const str = stringify3(data, options);
      outputFileSync(file, str, options);
    }
    module.exports = outputJsonSync;
  }
});

// ../../node_modules/fs-extra/lib/json/index.js
var require_json = __commonJS({
  "../../node_modules/fs-extra/lib/json/index.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    var jsonFile = require_jsonfile2();
    jsonFile.outputJson = u(require_output_json());
    jsonFile.outputJsonSync = require_output_json_sync();
    jsonFile.outputJSON = jsonFile.outputJson;
    jsonFile.outputJSONSync = jsonFile.outputJsonSync;
    jsonFile.writeJSON = jsonFile.writeJson;
    jsonFile.writeJSONSync = jsonFile.writeJsonSync;
    jsonFile.readJSON = jsonFile.readJson;
    jsonFile.readJSONSync = jsonFile.readJsonSync;
    module.exports = jsonFile;
  }
});

// ../../node_modules/fs-extra/lib/move/move.js
var require_move = __commonJS({
  "../../node_modules/fs-extra/lib/move/move.js"(exports, module) {
    "use strict";
    var fs2 = require_fs();
    var path2 = __require("path");
    var { copy } = require_copy2();
    var { remove } = require_remove();
    var { mkdirp } = require_mkdirs();
    var { pathExists: pathExists2 } = require_path_exists();
    var stat = require_stat();
    async function move(src, dest, opts = {}) {
      const overwrite = opts.overwrite || opts.clobber || false;
      const { srcStat, isChangingCase = false } = await stat.checkPaths(src, dest, "move", opts);
      await stat.checkParentPaths(src, srcStat, dest, "move");
      const destParent = path2.dirname(dest);
      const parsedParentPath = path2.parse(destParent);
      if (parsedParentPath.root !== destParent) {
        await mkdirp(destParent);
      }
      return doRename(src, dest, overwrite, isChangingCase);
    }
    async function doRename(src, dest, overwrite, isChangingCase) {
      if (!isChangingCase) {
        if (overwrite) {
          await remove(dest);
        } else if (await pathExists2(dest)) {
          throw new Error("dest already exists.");
        }
      }
      try {
        await fs2.rename(src, dest);
      } catch (err) {
        if (err.code !== "EXDEV") {
          throw err;
        }
        await moveAcrossDevice(src, dest, overwrite);
      }
    }
    async function moveAcrossDevice(src, dest, overwrite) {
      const opts = {
        overwrite,
        errorOnExist: true,
        preserveTimestamps: true
      };
      await copy(src, dest, opts);
      return remove(src);
    }
    module.exports = move;
  }
});

// ../../node_modules/fs-extra/lib/move/move-sync.js
var require_move_sync = __commonJS({
  "../../node_modules/fs-extra/lib/move/move-sync.js"(exports, module) {
    "use strict";
    var fs2 = require_graceful_fs();
    var path2 = __require("path");
    var copySync = require_copy2().copySync;
    var removeSync = require_remove().removeSync;
    var mkdirpSync = require_mkdirs().mkdirpSync;
    var stat = require_stat();
    function moveSync(src, dest, opts) {
      opts = opts || {};
      const overwrite = opts.overwrite || opts.clobber || false;
      const { srcStat, isChangingCase = false } = stat.checkPathsSync(src, dest, "move", opts);
      stat.checkParentPathsSync(src, srcStat, dest, "move");
      if (!isParentRoot(dest))
        mkdirpSync(path2.dirname(dest));
      return doRename(src, dest, overwrite, isChangingCase);
    }
    function isParentRoot(dest) {
      const parent = path2.dirname(dest);
      const parsedPath = path2.parse(parent);
      return parsedPath.root === parent;
    }
    function doRename(src, dest, overwrite, isChangingCase) {
      if (isChangingCase)
        return rename(src, dest, overwrite);
      if (overwrite) {
        removeSync(dest);
        return rename(src, dest, overwrite);
      }
      if (fs2.existsSync(dest))
        throw new Error("dest already exists.");
      return rename(src, dest, overwrite);
    }
    function rename(src, dest, overwrite) {
      try {
        fs2.renameSync(src, dest);
      } catch (err) {
        if (err.code !== "EXDEV")
          throw err;
        return moveAcrossDevice(src, dest, overwrite);
      }
    }
    function moveAcrossDevice(src, dest, overwrite) {
      const opts = {
        overwrite,
        errorOnExist: true,
        preserveTimestamps: true
      };
      copySync(src, dest, opts);
      return removeSync(src);
    }
    module.exports = moveSync;
  }
});

// ../../node_modules/fs-extra/lib/move/index.js
var require_move2 = __commonJS({
  "../../node_modules/fs-extra/lib/move/index.js"(exports, module) {
    "use strict";
    var u = require_universalify().fromPromise;
    module.exports = {
      move: u(require_move()),
      moveSync: require_move_sync()
    };
  }
});

// ../../node_modules/fs-extra/lib/index.js
var require_lib = __commonJS({
  "../../node_modules/fs-extra/lib/index.js"(exports, module) {
    "use strict";
    module.exports = {
      // Export promiseified graceful-fs:
      ...require_fs(),
      // Export extra methods:
      ...require_copy2(),
      ...require_empty(),
      ...require_ensure(),
      ...require_json(),
      ...require_mkdirs(),
      ...require_move2(),
      ...require_output_file(),
      ...require_path_exists(),
      ...require_remove()
    };
  }
});

// src/index.ts
import { mkdir as mkdir5 } from "node:fs/promises";
import {
  getBackendFolder as getBackendFolder2,
  getPageCodeFilePath as getPageCodeFilePath2,
  getPublicFolder as getPublicFolder2
} from "@wix/velo-github-layout-definitions";
import {
  getTypesDir as getTypesDir4,
  getBackendDTSPath as getBackendDTSPath2,
  getPageConfigFilename as getPageConfigFilename2,
  getBackendConfigPath as getBackendConfigPath2,
  getPublicConfigPath as getPublicConfigPath2,
  getPageElementsMapDTSFilename as getPageElementsMapDTSFilename2
} from "@wix/velo-types-definitions";

// src/configCreators/common-config.ts
import { readFile as readFile2, writeFile as writeFile2 } from "node:fs/promises";
import { join as join4, relative as relative3 } from "node:path";
import { parse, stringify } from "comment-json";

// src/helpers/fs-extra.ts
import { access, readFile, writeFile } from "node:fs/promises";
import { EOL } from "node:os";
import VError from "verror";
async function writeJson(file, object, opts) {
  const str = JSON.stringify(object, null, opts?.spaces).concat(EOL);
  await writeFile(file, str, "utf-8");
}
async function readJson(file) {
  const content = await readFile(file, "utf-8");
  try {
    return JSON.parse(content);
  } catch (e) {
    throw new VError(
      {
        name: "InvalidJsonFile",
        cause: e instanceof Error ? e : new Error(JSON.stringify(e))
      },
      `Invalid json file ${file}.`
    );
  }
}
function pathExists(path2) {
  return access(path2).then(() => true).catch(() => false);
}

// src/configCreators/public-files-types.ts
import { mkdir } from "node:fs/promises";
import { dirname as dirname2, join as join2, relative } from "node:path";

// src/helpers/wix-code-types-package.ts
import pacote from "pacote";
import pRetry from "p-retry";
import { getTypesDir } from "@wix/velo-github-layout-definitions";
import { dirname, join } from "node:path";
var import_fs_extra2 = __toESM(require_lib(), 1);
import { createRequire } from "node:module";
import { env } from "node:process";
var WIX_CODE_TYPES_DIR = "wix-code-types";
var require2 = createRequire(import.meta.url);
var customRegistry = env.VELO_NPM_REGISTRY;
function getBundledWixCodeTypesPath() {
  const packageJsonPath = require2.resolve("@wix/wix-code-types/package.json");
  return dirname(packageJsonPath);
}
async function copyBundledPackage(targetPath) {
  const bundledPath = getBundledWixCodeTypesPath();
  await import_fs_extra2.default.ensureDir(bundledPath);
  await import_fs_extra2.default.ensureDir(targetPath);
  await import_fs_extra2.default.copy(bundledPath, targetPath, {
    overwrite: true,
    errorOnExist: false
  });
}
async function installWixCodeTypesPackage(projectFolder) {
  const wixCodeTypesPackageJsonPath = join(
    wixCodeTypesPackagePath(projectFolder),
    "package.json"
  );
  const packageExists = await pathExists(wixCodeTypesPackageJsonPath);
  let localVersionIsLatest = false;
  let shouldUpdate = false;
  let canAccessNpm = true;
  try {
    if (packageExists) {
      const wixCodeTypesPackageJson = await readJson(
        wixCodeTypesPackageJsonPath
      );
      const latestManifest = await pacote.manifest("@wix/wix-code-types", {
        registry: customRegistry
      });
      localVersionIsLatest = latestManifest.version === wixCodeTypesPackageJson.version;
      shouldUpdate = !localVersionIsLatest;
    } else {
      shouldUpdate = true;
    }
  } catch (error) {
    if (packageExists) {
      return;
    }
    canAccessNpm = false;
    shouldUpdate = true;
  }
  if (shouldUpdate) {
    if (canAccessNpm) {
      try {
        await pRetry(
          async () => {
            await pacote.extract(
              "@wix/wix-code-types",
              wixCodeTypesPackagePath(projectFolder),
              { registry: customRegistry }
            );
          },
          { retries: 2 }
        );
        return;
      } catch (error) {
        if (packageExists) {
          return;
        }
      }
    }
    try {
      await copyBundledPackage(wixCodeTypesPackagePath(projectFolder));
    } catch (fallbackError) {
      throw new Error(
        `Failed to install @wix/wix-code-types from both npm registry and bundled dependency. Ensure @wix/wix-code-types is listed in package.json dependencies. ${fallbackError}`,
        { cause: fallbackError }
      );
    }
  }
}
function wixCodeTypesPackagePath(projectFolder) {
  return join(getTypesDir(projectFolder), WIX_CODE_TYPES_DIR);
}
function publicFilesTsConfigPath(projectFolder) {
  return join(
    wixCodeTypesPackagePath(projectFolder),
    "configs/tsconfig.public"
  );
}
function backendFilesTsConfigPath(projectFolder) {
  return join(
    wixCodeTypesPackagePath(projectFolder),
    "configs/tsconfig.backend"
  );
}
function pageFileTsConfigPath(projectFolder) {
  return join(wixCodeTypesPackagePath(projectFolder), "configs/tsconfig.page");
}

// src/configCreators/public-files-types.ts
async function writePublicFilesTypes(projectFolder, definitions) {
  const jsconfigPath = definitions.types.getPublicConfigPath(projectFolder);
  await mkdir(dirname2(jsconfigPath), { recursive: true });
  await writeJson(jsconfigPath, {
    extends: relative(
      dirname2(jsconfigPath),
      publicFilesTsConfigPath(projectFolder)
    ),
    compilerOptions: {
      composite: true,
      noEmit: false,
      paths: {
        "backend/*.web.js": [
          join2(
            relative(
              dirname2(jsconfigPath),
              definitions.layout.getBackendFolder(projectFolder)
            ),
            "*.web.js"
          )
        ],
        "backend/*.web": [
          join2(
            relative(
              dirname2(jsconfigPath),
              definitions.layout.getBackendFolder(projectFolder)
            ),
            "*.web.js"
          )
        ]
      },
      outDir: "build",
      rootDir: relative(dirname2(jsconfigPath), projectFolder)
    },
    references: [
      {
        path: relative(
          dirname2(jsconfigPath),
          definitions.types.getBackendConfigPath(projectFolder)
        )
      }
    ],
    include: [
      join2(
        relative(
          dirname2(jsconfigPath),
          definitions.layout.getPublicFolder(projectFolder)
        ),
        "**/*"
      ),
      relative(
        dirname2(jsconfigPath),
        definitions.types.getBackendDTSPath(projectFolder)
      )
    ]
  });
}

// src/configCreators/backend-files-types.ts
import { mkdir as mkdir2 } from "node:fs/promises";
import { join as join3, dirname as dirname3, relative as relative2 } from "node:path";
async function writeBackendFilesTypes(projectFolder, definitions) {
  const jsconfigPath = definitions.types.getBackendConfigPath(projectFolder);
  await mkdir2(dirname3(jsconfigPath), { recursive: true });
  await writeJson(jsconfigPath, {
    extends: relative2(
      dirname3(jsconfigPath),
      backendFilesTsConfigPath(projectFolder)
    ),
    compilerOptions: {
      composite: true,
      noEmit: false,
      outDir: "build",
      rootDir: relative2(dirname3(jsconfigPath), projectFolder),
      paths: {
        "public/*": [
          join3(
            relative2(
              dirname3(jsconfigPath),
              definitions.layout.getPublicFolder(projectFolder)
            ),
            "*"
          )
        ],
        "backend/*": [
          join3(
            relative2(
              dirname3(jsconfigPath),
              definitions.layout.getBackendFolder(projectFolder)
            ),
            "*"
          )
        ]
      }
    },
    references: [
      {
        path: relative2(
          dirname3(jsconfigPath),
          definitions.types.getPublicConfigPath(projectFolder)
        )
      }
    ],
    include: [
      join3(
        relative2(
          dirname3(jsconfigPath),
          definitions.layout.getBackendFolder(projectFolder)
        ),
        "**/*"
      )
    ]
  });
}

// src/configCreators/common-config.ts
async function getRootConfig(projectFolder) {
  const rootConfigPath = join4(projectFolder, "jsconfig.json");
  if (await pathExists(rootConfigPath)) {
    return parse(
      await readFile2(rootConfigPath, "utf8")
    );
  }
  return {};
}
async function writeRootConfig(projectFolder, rootConfig) {
  const rootConfigPath = join4(projectFolder, "jsconfig.json");
  await writeFile2(rootConfigPath, stringify(rootConfig, void 0, 2));
}
async function syncCommonConfig(projectFolder, pages, definitions) {
  const rootConfig = await getRootConfig(projectFolder);
  rootConfig.typeAcquisition = { enable: true };
  rootConfig.references = Object.keys(pages).map((pageId) => ({
    path: relative3(
      projectFolder,
      definitions.types.getPageConfigFilename(projectFolder, pageId)
    )
  }));
  await writeBackendFilesTypes(projectFolder, definitions);
  rootConfig.references.push({
    path: relative3(
      projectFolder,
      definitions.types.getBackendConfigPath(projectFolder)
    )
  });
  await writePublicFilesTypes(projectFolder, definitions);
  rootConfig.references.push({
    path: relative3(
      projectFolder,
      definitions.types.getPublicConfigPath(projectFolder)
    )
  });
  await writeRootConfig(projectFolder, rootConfig);
}
async function updateRootConfigPageReferences(projectFolder, createdPageIds, removedPageIds, definitions) {
  const rootConfig = await getRootConfig(projectFolder);
  const deletedPageRefs = removedPageIds.map(
    (pageId) => relative3(
      projectFolder,
      definitions.types.getPageConfigFilename(projectFolder, pageId)
    )
  );
  rootConfig.references = (rootConfig.references ?? []).filter((ref) => {
    return !deletedPageRefs.includes(ref.path);
  });
  rootConfig.references.push(
    ...createdPageIds.map((pageId) => ({
      path: relative3(
        projectFolder,
        definitions.types.getPageConfigFilename(projectFolder, pageId)
      )
    }))
  );
  await writeRootConfig(projectFolder, rootConfig);
}

// src/configCreators/page-types.ts
import { parse as parse2, stringify as stringify2 } from "comment-json";
import { mkdir as mkdir3, writeFile as writeFile3, rm as rm2, readFile as readFile3 } from "node:fs/promises";
import path, { dirname as dirname4, join as join6, relative as relative4 } from "node:path";

// src/helpers/utils.ts
import { HttpClient, HttpError } from "@wix/http-client";
import { getTypesDir as getTypesDir2 } from "@wix/velo-types-definitions";
import { join as join5 } from "node:path";
import VError2 from "verror";
import { readdir, rm, unlink } from "node:fs/promises";
import { existsSync } from "node:fs";
import { GridAppLayout } from "@wix/ambassador-velo-ide-v1-path-transform/build/cjs/types.impl";
async function httpRequest(opts, requestOptions) {
  try {
    return await new HttpClient(opts).request(requestOptions);
  } catch (e) {
    if (e instanceof HttpError) {
      if (e.response?.status === 403) {
        throw new VError2(
          {
            name: "PermissionDenied",
            cause: e
          },
          "Forbidden operation. Missing permissions"
        );
      }
      throw e;
    } else {
      throw e;
    }
  }
}
var cleanupTypes = async (projectFolder) => {
  const typesDir = getTypesDir2(projectFolder);
  if (!existsSync(typesDir)) {
    return Promise.resolve();
  }
  const filesOrDirs = await readdir(typesDir, { withFileTypes: true });
  const rootConfigPath = join5(projectFolder, "jsconfig.json");
  const files = filesOrDirs.filter((f) => f.isFile());
  const dirs = filesOrDirs.filter(
    (dir) => dir.isDirectory() && dir.name !== WIX_CODE_TYPES_DIR
  );
  return Promise.all([
    () => {
      if (existsSync(rootConfigPath)) {
        return unlink(rootConfigPath);
      }
      Promise.resolve();
    },
    ...files.map((file) => unlink(join5(typesDir, file.name))),
    ...dirs.map((dir) => rm(join5(typesDir, dir.name), { recursive: true }))
  ]);
};
var getPageCodeFilePathFromLayoutPath = (pFolder, page) => {
  return join5(pFolder, page.pageMetaData.layoutPath);
};
var isGridAppLayout = (layout) => {
  return typeof layout === "string" && isValidGridAppLayout(layout);
};
var isCustomLayout = (layout) => {
  return typeof layout === "function";
};
var isValidGridAppLayout = (layout) => {
  return Object.keys(GridAppLayout).includes(layout);
};
var widgetDtsContent = `declare global {
  namespace $widget {
    const props: any;
    function fireEvent(eventName: string, data: any): void;
    function onPropsChanged(handler: onPropsChangedHandler): any;
    type onPropsChangedHandler = (oldProps: any, newProps: any) => void;
  }
}

export {};`;

// src/configCreators/page-types.ts
import { GridAppLayout as GridAppLayout2 } from "@wix/ambassador-velo-ide-v1-gridapp-filestructure/build/cjs/types.impl.js";
async function syncTypesForPages(projectFolder, pagesData, definitions, hasMasterPage = true) {
  await writeFile3(
    definitions.types.getBackendDTSPath(projectFolder),
    'declare module "backend/*";'
  );
  await Promise.all(
    Object.entries(pagesData).map(async ([pageId, page]) => {
      const pageConfigDir = dirname4(
        definitions.types.getPageConfigFilename(
          projectFolder,
          page.pageMetaData.pageId
        )
      );
      await mkdir3(pageConfigDir, { recursive: true });
      const pageDeclarationsFiles = getPageDeclarationFiles(
        projectFolder,
        page,
        definitions,
        hasMasterPage
      );
      await Promise.all(
        Object.entries(pageDeclarationsFiles).map(
          async ([filename, content]) => {
            await writeFile3(join6(pageConfigDir, filename), content);
          }
        )
      );
      const jsConfigPath = definitions.types.getPageConfigFilename(
        projectFolder,
        pageId
      );
      await mkdir3(dirname4(jsConfigPath), { recursive: true });
      await writeJson(
        jsConfigPath,
        getConfigForPage(projectFolder, page, definitions),
        {
          spaces: 2
        }
      );
    })
  );
}
function getConfigForPage(projectFolder, page, definitions) {
  const configFilePath = definitions.types.getPageConfigFilename(
    projectFolder,
    page.pageMetaData.pageId
  );
  return {
    extends: relative4(
      dirname4(configFilePath),
      pageFileTsConfigPath(projectFolder)
    ),
    compilerOptions: {
      composite: true,
      noEmit: false,
      tsBuildInfoFile: ".tsbuildinfo",
      baseUrl: ".",
      jsx: "react",
      paths: {
        "public/*": [
          join6(
            relative4(
              dirname4(configFilePath),
              definitions.layout.getPublicFolder(projectFolder)
            ),
            "*"
          )
        ],
        "backend/*.web.js": [
          join6(
            relative4(
              dirname4(configFilePath),
              definitions.layout.getBackendFolder(projectFolder)
            ),
            "*.web.js"
          )
        ],
        "backend/*.web": [
          join6(
            relative4(
              dirname4(configFilePath),
              definitions.layout.getBackendFolder(projectFolder)
            ),
            "*.web.js"
          )
        ]
      },
      outDir: "build",
      rootDir: relative4(dirname4(configFilePath), projectFolder)
    },
    files: [
      relative4(
        dirname4(configFilePath),
        definitions.layout.getPageCodeFilePath(projectFolder, page, true)
      )
    ],
    references: [
      {
        path: relative4(
          dirname4(configFilePath),
          definitions.types.getBackendConfigPath(projectFolder)
        )
      },
      {
        path: relative4(
          dirname4(configFilePath),
          definitions.types.getPublicConfigPath(projectFolder)
        )
      }
    ],
    include: [
      ...Object.entries(
        getPageDeclarationFiles(projectFolder, page, definitions)
      ).map(([filename]) => filename),
      relative4(
        dirname4(configFilePath),
        definitions.types.getBackendDTSPath(projectFolder)
      )
    ]
  };
}
function getPageElementsMapContent(page) {
  const elementsString = Object.entries({ ...page.pageTypes.elements }).map(([nickname, type]) => `	"#${nickname}": ${type};`).join("\n");
  return `
${elementsString}
`;
}
var MASTER_PAGE_NAME = "masterPage";
function getPageDeclarationFiles(projectFolder, page, definitions, hasMasterPage = true) {
  const { pageId } = page.pageMetaData;
  const isMasterPage = pageId === MASTER_PAGE_NAME;
  const pageDTSFilename = definitions.types.getPageElementsMapDTSFilename(pageId);
  const pageElementsMapContent = getPageElementsMapContent(page);
  if (isMasterPage) {
    return {
      [pageDTSFilename]: `type MasterPageElementsMap = {${pageElementsMapContent}}`,
      "index.d.ts": `type PageElementsMap = MasterPageElementsMap;`
    };
  }
  let returnedDeclarationFiles;
  if (hasMasterPage) {
    const masterPageDTSDir = dirname4(
      definitions.types.getPageConfigFilename(projectFolder, MASTER_PAGE_NAME)
    );
    const pageDTSDir = dirname4(
      definitions.types.getPageConfigFilename(
        projectFolder,
        page.pageMetaData.pageId
      )
    );
    const masterPageDTSRelativePath = join6(
      relative4(pageDTSDir, masterPageDTSDir),
      definitions.types.getPageElementsMapDTSFilename(MASTER_PAGE_NAME)
    );
    returnedDeclarationFiles = {
      [pageDTSFilename]: `/// <reference path="${masterPageDTSRelativePath}" />
type PageElementsMap = MasterPageElementsMap & {${pageElementsMapContent}}`
    };
  } else {
    returnedDeclarationFiles = {
      [pageDTSFilename]: `type PageElementsMap = {${pageElementsMapContent}}`
    };
  }
  if (definitions.layout.outputLayout === GridAppLayout2.GITHUB_BLOCKS) {
    returnedDeclarationFiles["widget.d.ts"] = widgetDtsContent;
  }
  return returnedDeclarationFiles;
}
async function renamePage(projectFolder, pageId, newName, definitions) {
  const pageConfigFile = definitions.types.getPageConfigFilename(
    projectFolder,
    pageId
  );
  const pageConfig = parse2(
    await readFile3(pageConfigFile, "utf8")
  );
  pageConfig.files = [
    relative4(
      dirname4(pageConfigFile),
      definitions.layout.getPageCodeFilePath(projectFolder, {
        pageTitle: newName,
        pageMetaData: { pageId }
      })
    )
  ];
  await writeFile3(pageConfigFile, stringify2(pageConfig, void 0, 2));
}
async function deletePageTypes(projectFolder, pageId, definitions) {
  const pageConfigFile = definitions.types.getPageConfigFilename(
    projectFolder,
    pageId
  );
  await rm2(path.dirname(pageConfigFile), { recursive: true });
}

// src/helpers/pages-types-client.ts
import process2 from "node:process";
import {
  getSiteTypes,
  getLatestSiteTypes
} from "@wix/ambassador-typok-v1-site/http";
import { getLatestPageTypes } from "@wix/ambassador-typok-v1-page/http";
import verror from "verror";

// src/helpers/schemas.ts
import { z } from "zod";
var pageSchema = z.object({
  pageTitle: z.string().optional().default(""),
  pageMetaData: z.object({
    pageId: z.string(),
    layoutPath: z.string().optional().default(""),
    onlinePath: z.string().optional().default(""),
    missing: z.boolean().optional().default(false)
  }),
  pageTypes: z.object({
    elements: z.record(z.string()).optional()
  })
});
var siteSchema = z.object({
  pages: z.record(pageSchema)
});
var getSiteTypesSchema = z.object({
  site: siteSchema
});

// src/helpers/pages-types-client.ts
var { WError } = verror;
async function fetchPagesData(metaSiteId, revision, requestOptions) {
  let response;
  try {
    const useNewPagesApi = process2.env.USE_OLD_PAGES_API !== "true";
    const request = metaSiteId === void 0 ? getLatestSiteTypes({ useNewPagesApi }) : getSiteTypes({
      metaSiteId,
      revision: Number(revision),
      useNewPagesApi: process2.env.USE_OLD_PAGES_API !== "true"
    });
    response = await httpRequest(
      {
        ...requestOptions,
        timeout: 6e4,
        baseURL: "https://editor.wix.com"
      },
      request
    );
  } catch (e) {
    throw new WError(
      {
        name: "FailedToFetchPagesTypes",
        cause: e instanceof Error ? e : new Error(JSON.stringify(e)),
        info: {
          metaSiteId,
          revision
        }
      },
      `Failed to fetch the types of the site pages (revision ${revision})`
    );
  }
  try {
    return getSiteTypesSchema.parse(response.data).site.pages;
  } catch (e) {
    throw new WError(
      {
        name: "UnexpectedResponseFromPagesTypesService",
        cause: e instanceof Error ? e : new Error(JSON.stringify(e)),
        info: {
          data: response.data
        }
      },
      `Got unexpected response from server. Make sure you are running a supported version of the Velo CLI.`
    );
  }
}
async function fetchLatestPagesData(requestOptions) {
  return fetchPagesData(void 0, void 0, requestOptions);
}
async function fetchRevisionPagesData(metaSiteId, revision, requestOptions) {
  return fetchPagesData(metaSiteId, revision, requestOptions);
}
async function fetchLatestPageData(pageId, requestOptions) {
  let pageData;
  let response;
  try {
    const request = getLatestPageTypes({ pageId });
    response = await httpRequest(
      {
        ...requestOptions,
        baseURL: "https://editor.wix.com"
      },
      request
    );
    pageData = response.data?.page;
  } catch (e) {
    throw new WError(
      {
        name: "FailedToFetchLatestPageTypes",
        cause: e instanceof Error ? e : new Error(JSON.stringify(e)),
        info: {
          pageId
        }
      },
      `Failed to fetch the types of the page (pageId ${pageId})`
    );
  }
  if (!pageData) {
    throw new WError(
      {
        name: "UnexpectedResponseFromPagesTypesService",
        info: {
          data: response.data
        }
      },
      `Got unexpected response from server.`
    );
  }
  return pageData;
}

// src/agnosticTypeSyncer.ts
import { join as join7 } from "node:path";
import { mkdir as mkdir4 } from "node:fs/promises";
import { GridAppLayout as GridAppLayout4 } from "@wix/ambassador-velo-ide-v1-gridapp-filestructure/types";
import {
  getSourceFolder as getSourceFolder_,
  getTypesDir as getTypesDir3,
  getBackendDTSPath,
  getPageConfigFilename,
  getBackendConfigPath,
  getPublicConfigPath,
  getPageElementsMapDTSFilename
} from "@wix/velo-types-definitions";

// src/helpers/transformPathsFacade.ts
import { GridAppLayout as GridAppLayout3 } from "@wix/ambassador-velo-ide-v1-gridapp-filestructure/types";
import { transformPath } from "@wix/ambassador-velo-ide-v1-path-transform/http";
import { HttpClient as HttpClient2 } from "@wix/http-client";
var WIX_EDITOR_BASE_URL = "https://editor.wix.com";
var enrichFactory = (factory, headers) => {
  return (ctx) => ({
    ...factory(ctx),
    headers
  });
};
var transformPathsFacade = (layout = GridAppLayout3.GITHUB, getAppToken) => {
  const httpClientInstance = new HttpClient2({
    baseURL: WIX_EDITOR_BASE_URL,
    getAppToken
  });
  const ideNgTransformPaths = async (paths, headers) => {
    const transformPathRequestOptions = {
      pathTransforms: paths.sort((p1, p2) => p1.localeCompare(p2)).map((path2) => ({
        inputPath: path2,
        inputLayout: GridAppLayout3.ONLINE,
        outputLayout: layout
      }))
    };
    const transformPathFactory = enrichFactory(
      transformPath(transformPathRequestOptions),
      headers
    );
    return httpClientInstance.request(transformPathFactory).then(
      (res) => res.data.pathTransforms || []
    );
  };
  const toPathTransformation = (pathTransform) => ({
    inputPath: pathTransform.inputPath,
    outputPath: pathTransform.outputPath
  });
  return {
    toLayout: async (paths, headers) => {
      const pathTransforms = await ideNgTransformPaths(paths, headers);
      return pathTransforms.map(toPathTransformation);
    }
  };
};
var transformPathsFacade_default = transformPathsFacade;

// src/helpers/velo-online-layout-definitios.ts
var getPagesFolder = () => "public/pages";
var getPublicFolder = () => "public";
var getBackendFolder = () => "backend";
var getPageCodeFilePath = (pageId) => `${getPagesFolder()}/${pageId}.js`;

// src/helpers/calculate-pages-map-diffs.ts
var calculatePagesMapDiffs = (currentMap, newMap) => {
  const created = [];
  newMap.forEach((targetPath, pageId) => {
    if (!currentMap.has(pageId)) {
      created.push({ id: pageId, targetPath });
    }
  });
  const deleted = [];
  currentMap.forEach((targetPath, pageId) => {
    if (!newMap.has(pageId)) {
      deleted.push({ id: pageId, targetPath });
    }
  });
  const renamed = [];
  currentMap.forEach((sourcePath, pageId) => {
    if (newMap.has(pageId) && newMap.get(pageId) !== sourcePath) {
      renamed.push({
        id: pageId,
        targetPath: newMap.get(pageId),
        sourcePath
      });
    }
  });
  return { created, deleted, renamed };
};
var calculate_pages_map_diffs_default = calculatePagesMapDiffs;

// src/helpers/customLayoutTransformer.ts
var customLayoutTransformer = (pathTransformer) => {
  return {
    toLayout: async (paths, headers) => {
      const trasnformedPaths = await Promise.all(
        paths.map((path2) => pathTransformer(path2, headers))
      );
      return trasnformedPaths.map((outputPath, index) => {
        if (outputPath !== void 0) {
          return {
            inputPath: paths[index],
            outputPath
          };
        } else {
          return void 0;
        }
      }).filter(
        (pathTransform) => pathTransform !== void 0
      );
    }
  };
};
var customLayoutTransformer_default = customLayoutTransformer;

// src/helpers/offlinePages.ts
import { sdkTypes } from "@wix/wix-code-sdk-viewer-types";
var validatePagesConsistency = (pages) => {
  const isOfflinePageMap = pages.map((page) => "elements" in page);
  if (isOfflinePageMap.some((isOfflinePage) => isOfflinePage) && isOfflinePageMap.some((isOfflinePage) => !isOfflinePage)) {
    throw new Error(
      "Inconsistent data: Mixing regular pages with offline pages is not supported."
    );
  }
};
var isOfflinePageArray = (pages) => pages.every((page) => "elements" in page);
var getElementsInSdkType = (elements) => Object.fromEntries(
  Object.entries(elements).map(([key, viewerType]) => [
    key,
    sdkTypes.getFullSdkType({ viewerType: viewerType ?? void 0 })
  ])
);
var getPagesDataForOfflinePages = (offlinePages) => offlinePages.reduce((pagesData, offlinePage) => {
  const elementsInSdkType = getElementsInSdkType(offlinePage.elements);
  const pageData = pageSchema.parse({
    pageMetaData: { pageId: offlinePage.id },
    pageTypes: { elements: elementsInSdkType }
  });
  return { ...pagesData, [offlinePage.id]: pageData };
}, {});

// src/agnosticTypeSyncer.ts
var MASTER_PAGE_ID = "masterPage";
var createAgnosticTypeSyncer = async (projectFolder, layout = GridAppLayout4.GITHUB, options = {}) => {
  if (!projectFolder) {
    throw new Error("projectFolder is required");
  }
  const { getAppToken, headers } = options;
  const layoutTransformer = getLayoutTransformer();
  let _pagesMap = /* @__PURE__ */ new Map();
  let responsePathTransform;
  try {
    responsePathTransform = await layoutTransformer.toLayout(
      [getPublicFolder(), getBackendFolder()],
      headers
    );
  } catch (error) {
    throw new Error(`Failed to transform paths with Error: ${error.message}`);
  }
  const [publicFolder] = responsePathTransform.filter(
    (pathTransforms) => pathTransforms?.inputPath === getPublicFolder()
  ).map((pathTransforms) => pathTransforms?.outputPath);
  const [backendFolder] = responsePathTransform.filter(
    (pathTransforms) => pathTransforms?.inputPath === getBackendFolder()
  ).map((pathTransforms) => pathTransforms?.outputPath);
  if (!publicFolder || !backendFolder) {
    throw new Error(
      `Failed to transform paths, getting empty path response for ${getPublicFolder()}: ${publicFolder} and ${getBackendFolder()}: ${backendFolder}`
    );
  }
  const pathDefinitions = {
    layout: {
      getPageCodeFilePath: getPageCodeFilePathFromLayoutPath,
      getBackendFolder: (projectFolder_ = "") => join7(projectFolder_, backendFolder),
      getPublicFolder: (projectFolder_ = "") => join7(projectFolder_, publicFolder),
      outputLayout: layout
    },
    types: {
      getBackendConfigPath,
      getTypesDir: getTypesDir3,
      getBackendDTSPath,
      getPageConfigFilename,
      getPublicConfigPath,
      getPageElementsMapDTSFilename
    }
  };
  const hasMasterPage = (pMap) => pMap.has(MASTER_PAGE_ID);
  function getLayoutTransformer() {
    if (isGridAppLayout(layout)) {
      if (!getAppToken) {
        throw new Error("getAppToken is required for GridAppLayout");
      }
      return transformPathsFacade_default(layout, getAppToken);
    } else if (isCustomLayout(layout)) {
      return customLayoutTransformer_default(layout);
    } else {
      throw new Error(`${layout} is invalid layout type`);
    }
  }
  const enrichPagesData = async (pagesData = {}, syncSiteOptions) => {
    const { headers: syncSiteHeaders = {} } = syncSiteOptions;
    if (!Object.keys(pagesData).length) {
      return pagesData;
    }
    Object.keys(pagesData).forEach((pageId) => {
      const onlinePath = getPageCodeFilePath(pageId);
      pagesData[pageId].pageMetaData.onlinePath = onlinePath;
    });
    const pagesDataTransformPaths = await layoutTransformer.toLayout(
      Object.keys(pagesData).map(
        (pageId) => pagesData[pageId].pageMetaData.onlinePath
      ),
      syncSiteHeaders
    );
    Object.keys(pagesData).forEach((pageId) => {
      const pageLayoutPath = pagesDataTransformPaths.find(
        ({ inputPath }) => inputPath === pagesData[pageId].pageMetaData.onlinePath
      );
      pagesData[pageId].pageMetaData.layoutPath = pageLayoutPath?.outputPath ?? "";
    });
    Object.keys(pagesData).forEach((pageId) => {
      if (!pagesData[pageId].pageMetaData.layoutPath) {
        delete pagesData[pageId];
      }
    });
    return pagesData;
  };
  const syncSitePagesDiff = async (syncSiteOptions) => {
    const { headers: syncSiteHeaders = {}, offlinePages } = syncSiteOptions;
    let pagesData;
    if (offlinePages) {
      pagesData = getPagesDataForOfflinePages(offlinePages);
    } else {
      pagesData = await fetchLatestPagesData({
        headers: syncSiteHeaders,
        getAppToken
      });
    }
    const pagesDataEnriched = await enrichPagesData(pagesData, syncSiteOptions);
    const newPagesMap = /* @__PURE__ */ new Map();
    Object.keys(pagesDataEnriched).forEach((pageId) => {
      newPagesMap.set(
        pageId,
        pagesDataEnriched[pageId].pageMetaData.layoutPath
      );
    });
    const { created, deleted, renamed } = calculate_pages_map_diffs_default(
      _pagesMap,
      newPagesMap
    );
    await Promise.all([
      ...created.concat(renamed).map(
        async ({ id }) => syncTypesForPages(
          projectFolder,
          { [id]: pagesDataEnriched[id] },
          pathDefinitions,
          hasMasterPage(newPagesMap)
        )
      ),
      ...deleted.map(
        async ({ id }) => deletePageTypes(projectFolder, id, pathDefinitions)
      )
    ]);
    await updateRootConfigPageReferences(
      projectFolder,
      created.map((page) => page.id),
      deleted.map((page) => page.id),
      pathDefinitions
    );
    _pagesMap = new Map(newPagesMap);
    return { created, deleted, renamed };
  };
  const syncSite = async (syncSiteOptions = { onlyPages: false }) => {
    const {
      onlyPages,
      headers: syncSiteHeaders,
      offlinePages
    } = syncSiteOptions;
    if (!onlyPages) {
      await cleanupTypes(projectFolder);
      await mkdir4(getTypesDir3(projectFolder), {
        recursive: true
      });
      try {
        await installWixCodeTypesPackage(projectFolder);
      } catch (error) {
        console.log(error);
      }
      let pagesData;
      if (offlinePages) {
        pagesData = getPagesDataForOfflinePages(offlinePages);
      } else {
        pagesData = await fetchLatestPagesData({
          headers: syncSiteHeaders,
          getAppToken
        });
      }
      const pagesDataEnriched = await enrichPagesData(
        pagesData,
        syncSiteOptions
      );
      const newPagesMap = /* @__PURE__ */ new Map();
      Object.keys(pagesDataEnriched).forEach((pageId) => {
        newPagesMap.set(
          pageId,
          pagesDataEnriched[pageId].pageMetaData.layoutPath
        );
      });
      await Promise.all([
        syncCommonConfig(projectFolder, pagesDataEnriched, pathDefinitions),
        syncTypesForPages(
          projectFolder,
          pagesDataEnriched,
          pathDefinitions,
          hasMasterPage(newPagesMap)
        )
      ]);
      const { created, deleted, renamed } = calculate_pages_map_diffs_default(
        _pagesMap,
        newPagesMap
      );
      _pagesMap = new Map(newPagesMap);
      return { created, deleted, renamed };
    } else {
      return syncSitePagesDiff(syncSiteOptions);
    }
  };
  const syncPages = async (pages, syncPagesOptions = {}) => {
    validatePagesConsistency(pages);
    const newPagesMap = new Map(_pagesMap);
    let createdOrUpdatedPagesData;
    if (isOfflinePageArray(pages)) {
      createdOrUpdatedPagesData = getPagesDataForOfflinePages(pages);
    } else {
      const data = await Promise.all(
        pages.map(
          ({ id }) => fetchLatestPageData(id, { ...syncPagesOptions, getAppToken })
        )
      );
      createdOrUpdatedPagesData = data.reduce((acc, pageData) => {
        if (pageData?.pageMetaData?.pageId && !pageData?.pageMetaData?.missing) {
          acc[pageData.pageMetaData.pageId] = pageData;
        }
        return acc;
      }, {});
      const missingPagesData = data.reduce((acc, pageData) => {
        if (pageData?.pageMetaData?.missing) {
          acc[pageData.pageMetaData.pageId] = pageData;
        }
        return acc;
      }, {});
      Object.keys(missingPagesData).forEach((page) => {
        if (newPagesMap.has(page)) {
          newPagesMap.delete(page);
        }
      });
    }
    const pagesDataEnriched = await enrichPagesData(
      createdOrUpdatedPagesData,
      syncPagesOptions
    );
    Object.keys(pagesDataEnriched).forEach((page) => {
      newPagesMap.set(page, pagesDataEnriched[page].pageMetaData.layoutPath);
    });
    const { created, deleted, renamed } = calculate_pages_map_diffs_default(
      _pagesMap,
      newPagesMap
    );
    await Promise.all([
      ...Object.keys(pagesDataEnriched).map(
        async (pageId) => syncTypesForPages(
          projectFolder,
          { [pageId]: pagesDataEnriched[pageId] },
          pathDefinitions,
          hasMasterPage(newPagesMap)
        )
      ),
      ...deleted.map(
        async ({ id }) => deletePageTypes(projectFolder, id, pathDefinitions)
      )
    ]);
    await updateRootConfigPageReferences(
      projectFolder,
      created.map((page) => page.id),
      deleted.map((page) => page.id),
      pathDefinitions
    );
    _pagesMap = new Map(newPagesMap);
    return { created, deleted, renamed };
  };
  const deletePages = async (pages) => {
    const tryingToDeleteMasterPage = pages.some(
      (page) => page.id === MASTER_PAGE_ID
    );
    if (tryingToDeleteMasterPage) {
      throw new Error("masterPage should not be deleted");
    }
    const newPagesMap = new Map(_pagesMap);
    const deleted = [];
    pages.forEach((page) => {
      const targetPath = newPagesMap.get(page.id);
      if (targetPath) {
        newPagesMap.delete(page.id);
        deleted.push({ id: page.id, targetPath });
      }
    });
    await Promise.all([
      ...deleted.map(
        async ({ id }) => deletePageTypes(projectFolder, id, pathDefinitions)
      )
    ]);
    await updateRootConfigPageReferences(
      projectFolder,
      [],
      deleted.map((page) => page.id),
      pathDefinitions
    );
    _pagesMap = new Map(newPagesMap);
    return { created: [], deleted, renamed: [] };
  };
  return {
    syncSite,
    syncPages,
    deletePages,
    getPagesMap: () => new Map(_pagesMap),
    layoutDefinition: {
      getSourceFolder: () => getSourceFolder_(projectFolder),
      getPublicFolder: () => join7(projectFolder, publicFolder),
      getBackendFolder: () => join7(projectFolder, backendFolder)
    }
  };
};
var agnosticTypeSyncer_default = createAgnosticTypeSyncer;

// src/index.ts
var defaultDefinitions = {
  layout: {
    getBackendFolder: getBackendFolder2,
    getPageCodeFilePath: getPageCodeFilePath2,
    getPublicFolder: getPublicFolder2
  },
  types: {
    getBackendConfigPath: getBackendConfigPath2,
    getTypesDir: getTypesDir4,
    getBackendDTSPath: getBackendDTSPath2,
    getPageConfigFilename: getPageConfigFilename2,
    getPublicConfigPath: getPublicConfigPath2,
    getPageElementsMapDTSFilename: getPageElementsMapDTSFilename2
  }
};
async function syncRevisionTypes(model, requestOptions, definitions = defaultDefinitions) {
  const pagesData = await fetchRevisionPagesData(
    model.metaSiteId,
    model.revision,
    requestOptions
  );
  await syncTypes(model.projectFolder, pagesData, definitions);
}
async function syncLatestTypes(projectFolder, requestOptions, definitions = defaultDefinitions) {
  const pagesData = await fetchLatestPagesData(requestOptions);
  await syncTypes(projectFolder, pagesData, definitions);
}
async function syncPageLatestTypes(projectFolder, pageId, requestOptions, definitions = defaultDefinitions) {
  const pageData = await fetchLatestPageData(pageId, requestOptions);
  if (pageData === void 0) {
    return;
  }
  const pagesData = {
    [pageId]: pageData
  };
  await syncTypesForPages(projectFolder, pagesData, definitions);
}
async function syncLatestTypesForPagesDiff(projectFolder, { createdPages, deletedPages, renamedPages }, requestOptions, definitions = defaultDefinitions) {
  await Promise.all([
    ...createdPages.map(
      async ({ pageId }) => syncPageLatestTypes(projectFolder, pageId, requestOptions, definitions)
    ),
    ...deletedPages.map(
      async ({ pageId }) => deletePageTypes(projectFolder, pageId, definitions)
    ),
    ...renamedPages.map(
      ({ pageId, newName }) => renamePage(projectFolder, pageId, newName, definitions)
    )
  ]);
  await updateRootConfigPageReferences(
    projectFolder,
    createdPages.map((p) => p.pageId),
    deletedPages.map((p) => p.pageId),
    definitions
  );
}
async function syncTypes(projectFolder, pagesData, definitions = defaultDefinitions) {
  await mkdir5(definitions.types.getTypesDir(projectFolder), {
    recursive: true
  });
  await installWixCodeTypesPackage(projectFolder);
  await Promise.all([
    syncCommonConfig(projectFolder, pagesData, definitions),
    syncTypesForPages(projectFolder, pagesData, definitions)
  ]);
}
export {
  agnosticTypeSyncer_default as createAgnosticTypeSyncer,
  defaultDefinitions,
  syncLatestTypes,
  syncLatestTypesForPagesDiff,
  syncPageLatestTypes,
  syncRevisionTypes
};
